import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
//import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import callApi from '../../helpers/apiCaller';
//import data from './data.json';
//import callApiNone from '../../helpers/apiCallerNone';
import getCachedData from 'helpers/getStoreCache';
import $ from 'jquery';
import _ from 'lodash';
import Countdown from 'react-countdown';
//import MathJax from 'react-mathjax-preview';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import config from '../../common/config';
//import MathElement from "../../common/MathML1";
import { v1 as uuid } from 'uuid';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from 'ckeditor5-build-classic-mathtype';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from 'ckeditor5-build-classic-mathtype';
import HtmlParse from 'html-react-parser';
import { Base64 } from 'js-base64';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  divideSubjectType1,
  divideSubjectType2,
  divideSubjectType3,
  divideSubjectType4,
  divideSubjectType5,
  divideSubjectType5SubPart,
  showMessagePartTHPT
} from '../../common/config';
import { setArrAnswerPart2, setArrAnswerPart3 } from './answerStore';
import {
  formatObjectToString,
  seperatePart2,
  transformAnswers
} from './ChiaPhanMonThi';

const useStyles = makeStyles((theme) => ({}));

const StudentExamTHPT2025 = (props) => {
  const [firstArray, setFirstArray] = useState([]);
  const [secondArray, setSecondArray] = useState([]);
  const [thirdArray, setThirdArray] = useState([]);
  const [firstArraySubPart, setFirstArraySubPart] = useState([]);
  const [secondArraySubPart, setSecondArraySubPart] = useState([]);
  const [thirdArraySubPart, setThirdArraySubPart] = useState([]);
  const [questionArr, setQuestionArr] = useState([]);
  const dispatch = useDispatch();
  const answerPart2Prev = useSelector((state) => state.answer.arrAnsPart2);
  const answerPart3Prev = useSelector((state) => state.answer.arrAnsPart3);
  const [curStatus, setCurStatus] = useState(0);

  // hot fix
  let answerPart2Ques1 = '';
  let answerPart2Ques2 = '';
  let answerPart2Ques3 = '';
  let answerPart2Ques4 = '';
  let answerPart2Ques5 = '';
  let answerPart2Ques6 = '',
    answerPart2Ques7 = '',
    answerPart2Ques8 = '',
    answerPart2Ques9 = '',
    answerPart2Ques10 = '',
    answerPart2Ques11 = '',
    answerPart2Ques12 = '',
    answerPart2Ques13 = '',
    answerPart2Ques14 = '',
    answerPart2Ques15 = '',
    answerPart2Ques16 = '',
    answerPart2Ques17 = '',
    answerPart2Ques18 = '',
    answerPart2Ques19 = '',
    answerPart2Ques20 = '',
    answerPart2Ques21 = '',
    answerPart2Ques22 = '',
    answerPart2Ques23 = '',
    answerPart2Ques24 = '',
    answerPart2Ques25 = '',
    answerPart2Ques26 = '',
    answerPart2Ques27 = '',
    answerPart2Ques28 = '',
    answerPart2Ques29 = '',
    answerPart2Ques30 = '',
    answerPart2Ques31 = '',
    answerPart2Ques32 = '',
    answerPart2Ques33 = '',
    answerPart2Ques34 = '',
    answerPart2Ques35 = '',
    answerPart2Ques36 = '',
    answerPart2Ques37 = '',
    answerPart2Ques38 = '',
    answerPart2Ques39 = '',
    answerPart2Ques40 = '',
    answerPart2Ques41 = '',
    answerPart2Ques42 = '',
    answerPart2Ques43 = '',
    answerPart2Ques44 = '',
    answerPart2Ques45 = '',
    answerPart2Ques46 = '',
    answerPart2Ques47 = '',
    answerPart2Ques48 = '',
    answerPart2Ques49 = '',
    answerPart2Ques50 = '';

  var cookies = new Cookies();
  var accessToken = cookies.get('access_token');
  if (accessToken == undefined) {
    //login gv
    accessToken = window.localStorage.getItem('AccessToken');
  }
  if (accessToken == undefined) {
    // hs
    accessToken = '';
  }

  var header = { authorization: accessToken };
  const { history } = props;

  const statusExam = useRef(false);
  const questionTypeId = useRef(1);

  const totalDurationsCurr = useRef(0);

  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [tracking, setTracking] = useState([]);
  const [exams, setExams] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionsData, setQuestionsData] = useState([]);
  const [gid, setGID] = useState('');
  const [examRecordId, setExamRecordId] = useState('');
  const examRecordIdCurrent = useRef('');
  const gidCurrent = useRef('');
  const [disconnectNumber, setDisconnectNum] = useState(0);

  const [assignArrNext, setAssignArrNext] = useState('');

  const [username, setUsername] = useState('');
  const [schoolname, setSchoolname] = useState('');
  const [roomname, setRoomname] = useState('');
  const [examname, setExamname] = useState('');
  const [subjectname, setSubjectname] = useState('');
  const [durations, setDurations] = useState(0);
  const [totalDurations, setTotalDurations] = useState(0);
  const [currentMunutes, setCurrentMunutes] = useState(0);
  const [currentSeconds, setCurrentSeconds] = useState(0);
  const [numOfQuestions, setNumOfQuestions] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);

  const [trackingQuestionId, setTrackingQuestionId] = useState(0);
  const [trackingAnswer, setTrackingAnswer] = useState('');
  //const [statusExam, setStatusExam] = useState(false);
  const [fileUploadName, setFileUploadName] = useState();
  const [fileUploadFiles, setFileUploadFiles] = useState();
  const [fileUploaded, setFileUploaded] = useState([]);
  const [contentCK, setContentCK] = useState('');
  const checkDevice = useRef(false);
  //const statusOnline = useRef(true);
  const [statusOnline, setStatusOnline] = useState(true);
  const subjectId = useRef(0);
  const isFree = useRef(false);
  //const [orientationType, setOrientationType] = useState(0);
  const orientationType = useRef(0);
  const offCheating = useRef(false); // false: bật, true: tắt

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });
  var userStore = {};
  let assignArr = '';
  var idUrl = '';
  var numOfQuestion = 0;
  var spendTime = 0;
  var checkExam = false;
  var refeshNum = 0;
  var outExam = 0;
  let gid_applyId = 0;
  let linkExam = '/de-thi-can-lam';

  let duration = 0;
  var current = 60;
  //var currentMunute = duration - 1 - spendTime / 60;
  var currentMunute = 0;
  var totalQuestion = parseInt(numOfQuestion);
  var totalDuration = parseInt(duration);
  var qArr = Array();
  // disconnectNum = 0;
  var disconnectNum = 0;

  const renderer = ({ seconds, completed }) => {
    return <span>{seconds}</span>;
  };

  const rendererImages = (id, idx, vl) => {
    return (
      <div
        className="col-6 col-md-2 iw-upload-item"
        id={`boximages_${id}_${idx}`}>
        <input
          type="hidden"
          className={`hiddenUpload_${id}_${1}`}
          id={`hiddenUpload_${id}_${idx}`}
          name={`hiddenUpload_${id}_${idx}`}
          value={vl}
        />
        <div className="iw-image-upload">
          <div className="iw-image-upload-inner ratio-1-1">
            <img src={process.env.REACT_APP_DOMAIN_IMAGE + '/' + vl} alt="" />
          </div>
          <a
            href="javascript:void(0);"
            className="iw-image-upload-delete"
            onClick={(e) => removeBoxImage(`${id}_${idx}`, id, 1, 1)}>
            <i className="fas fa-times" />
          </a>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const funcEventBlur = (e) => {
      if (statusExam.current == true) {
        return false;
      }
      const prevType = $(this).data('prevType');
      if (prevType != e.type) {
        //  reduce double fire issues
        switch (e.type) {
          case 'blur':
            break;
          case 'focus':
            timeCurrent = 5; // 15
            clearInterval(cClearTime);
            return false;
            break;
        }
      }

      //if (process.env.REACT_APP_ENABLEINFO == "1" && questionTypeId.current == 4) {
      if (!offCheating.current && questionTypeId.current == 4) {
        if (document.cookie.indexOf('noblur') == -1) {
          // not exists
          cClearTime = setInterval(function () {
            timeCurrent--;
            if (timeCurrent < 0) {
              autoSaveTest(2); // outexam
              document.cookie = 'showblur=noblur; path=/';
              statusExam.current = true;
              swal({
                text: 'Vui lòng liên hệ giáo viên để được cấp quyền thi lại vì bạn đã làm việc riêng trong thời gian làm bài.',
                icon: 'warning',
                buttons: ['Đóng', 'Liên hệ'],
                dangerMode: true
              }).then(async (willDelete) => {
                ClearCookie();
                window.location.href = linkExam;
              });
              clearInterval(cClearTime);
              clearTimeout(cClearTime);
              return false;
            }
          }, 1000);
        } else {
          //exists
          autoSaveTest(2); // outexam
          swal({
            text: 'Vui lòng liên hệ giáo viên để được cấp quyền thi lại vì bạn đã làm việc riêng trong thời gian làm bài.',
            icon: 'warning',
            buttons: ['Đóng', 'Liên hệ'],
            dangerMode: true
          }).then((willDelete) => {
            if (willDelete) {
              ClearCookie();
              window.location.href = linkExam;
            }
          });
          //clearInterval(cClearTime);
          //clearTimeout(cClearTime);
          return false;
        }
      }

      //if (process.env.REACT_APP_ENABLEINFO == "1" && questionTypeId.current == 4) {
      if (!offCheating.current && questionTypeId.current == 4) {
        if (document.cookie.indexOf('noblur') == -1 && e.type == 'blur') {
          //swal("", "Vui lòng không làm việc riêng trong thời gian làm bài. Hệ thống sẽ tự động nộp bài sau 15 giây nếu bạn không quay lại trang thi.", "warning", {
          swal(
            '',
            'Vui lòng không làm việc riêng trong thời gian làm bài. Hệ thống sẽ tự động nộp bài sau 5 giây nếu bạn không quay lại trang thi.',
            'warning',
            {
              button: 'OK'
            }
          );
        }
      }

      $(this).data('prevType', e.type);
    };
    // $(window).on('blur focus', );
    window.addEventListener('blur', funcEventBlur);
    window.addEventListener('focus', funcEventBlur);
    return () => {
      window.removeEventListener('blur', funcEventBlur);
      window.removeEventListener('focus', funcEventBlur);
    };
  }, []);

  useEffect(() => {
    (async () => {
      var queryParams = config.getUrlQueryParams();
      await getCachedData('user_store', '/').then((response) => {
        if (response != undefined) {
          userStore = JSON.parse(response);
          if (userStore != undefined && userStore.username != undefined) {
            setUsername(userStore.fullname);
          } else {
            //window.location.href = "/dang-nhap";
          }
        } else {
          //window.location.href = "/dang-nhap";
        }
      });
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        checkDevice.current = true;
      }

      if (
        queryParams[0].split('=')[1] == 0 ||
        queryParams[0].split('=')[1] == undefined ||
        queryParams[0].split('=')[1] == NaN
      ) {
        setQuestions([]);
        swal('', 'Bài thi không đúng. Vui lòng kiểm tra lại', 'warning', {
          button: 'OK'
        });
        return false;
      } else {
        //gid_applyId = parseInt(queryParams[0].split('=')[1]);
        gid_applyId = queryParams[0].split('=')[1];
        setGID(gid_applyId);

        var body = {
          gid: queryParams[0].split('=')[1],
          content_type: 1,
          client_timing: new Date().getTime()
        };

        // Lấy đề làm bài thi
        var apiBaseUrl = config.getRootURL() + '/gd/v3/student_exams/do_test';
        config.showLoader();
        await callApi(apiBaseUrl, 'POST', body, header)
          .then(function (response) {
            if (response == false) {
              config.hideLoader();
              statusExam.current = true;
              swal({
                text: 'Bài thi không tồn tại. Vui lòng liên hệ giáo viên để được hổ trợ',
                icon: 'warning',
                buttons: true,
                dangerMode: true
              }).then((willDelete) => {
                window.location.href = '/de-thi-can-lam';
              });

              return false;
            } else if (response == 1) {
              config.hideLoader();
              statusExam.current = true;
              return false;
            }

            if (response.data.data.questions != undefined) {
              config.hideLoader();
              // Chống mất đáp án phần 2
              let arrAnswerPart2;
              // let arrAnswerPart2 = response.data.data.questions?.slice(12, 16).map(question => ({
              //   id: question.id,
              //   answer: question.answerOfStudent
              // }))

              //// de thpt 2025
              // tổng câu
              var totalP1 = response.data.data.questions.filter(
                (x) => x.sub_question_type_id == 1
              ).length;
              var totalP2 = response.data.data.questions.filter(
                (x) => x.sub_question_type_id == 2
              ).length;
              var totalP3 = response.data.data.questions.filter(
                (x) => x.sub_question_type_id == 3
              ).length;
              var totalMapP1 = totalP1;
              var totalMapP2 = totalP1 + totalP2;
              var totalMapP3 = totalP1 + totalP2 + totalP3;
              totalQuestion = totalP1 + totalP2 * 4 + totalP3;
              ///////////

              // 1 Toán
              if (response.data.data.exam.subject_id === 1) {
                const dividePart = divideSubjectType1(
                  response.data.data.questions,
                  totalMapP1,
                  totalMapP2,
                  totalMapP3
                );
                const { part1, part2, part3 } = dividePart;
                arrAnswerPart2 = part2?.map((question) => ({
                  id: question.id,
                  answer: question.answerOfStudent
                }));
              } else if (
                // 6 Lý, 7 Hóa, 9 Sinh, 11 Địa
                response.data.data.exam.subject_id === 6 ||
                response.data.data.exam.subject_id === 7 ||
                response.data.data.exam.subject_id === 9 ||
                response.data.data.exam.subject_id === 11
              ) {
                const dividePart = divideSubjectType2(
                  response.data.data.questions,
                  totalMapP1,
                  totalMapP2,
                  totalMapP3
                );
                const { part1, part2, part3 } = dividePart;
                arrAnswerPart2 = part2?.map((question) => ({
                  id: question.id,
                  answer: question.answerOfStudent
                }));
              } else if (
                // 10 Sử, 12 GDCD, 15 [CN công nghiệp, CN nông nghiệp], 31 Giáo dục kinh tế & Pháp luật
                response.data.data.exam.subject_id === 10 ||
                response.data.data.exam.subject_id === 12 ||
                response.data.data.exam.subject_id === 15 ||
                response.data.data.exam.subject_id === 31
              ) {
                const dividePart = divideSubjectType3(
                  response.data.data.questions,
                  totalMapP1,
                  totalMapP2,
                  totalMapP3
                );
                const { part1, part2 } = dividePart;
                arrAnswerPart2 = part2?.map((question) => ({
                  id: question.id,
                  answer: question.answerOfStudent
                }));
              } else if (
                // 8 Anh
                response.data.data.exam.subject_id === 8
              ) {
                const dividePart = divideSubjectType4(
                  response.data.data.questions,
                  totalMapP1,
                  totalMapP2,
                  totalMapP3
                );
                const { part1, part2 } = dividePart;
                arrAnswerPart2 = part2.map((question) => ({
                  id: question.id,
                  answer: question.answerOfStudent
                }));
              } else if (
                // 14 Tin
                response.data.data.exam.subject_id === 14
              ) {
                const dividePart = divideSubjectType5(
                  response.data.data.questions,
                  totalMapP1,
                  totalMapP2,
                  totalMapP3
                );
                const { part1, part2 } = dividePart;
                arrAnswerPart2 = part2?.map((question) => ({
                  id: question.id,
                  answer: question.answerOfStudent
                }));
              } // // cac mon khong thuoc thpt 2025
              else {
                const dividePart = divideSubjectType1(
                  response.data.data.questions,
                  totalMapP1,
                  totalMapP2,
                  totalMapP3
                );
                const { part1, part2, part3 } = dividePart;
                arrAnswerPart2 = part2?.map((question) => ({
                  id: question.id,
                  answer: question.answerOfStudent
                }));
              }

              const transformedArray = arrAnswerPart2;
              if (!_.isEmpty(transformedArray)) {
                arrAnswerPart2 = arrAnswerPart2?.map((item) => ({
                  id: item.id,
                  arrAnswer: item.answer.split(/(?=a[1-4])/)
                }));
                arrAnswerPart2 = transformAnswers(arrAnswerPart2);
                arrAnswerPart2.forEach((item) => {
                  ['a1', 'a2', 'a3', 'a4'].forEach((key) => {
                    if (item[key]) {
                      setTimeout(() => {
                        $(`#q_btn_${item.id}${key}`).addClass('active');
                        $(`#q_btn_${item.id}${key}`).addClass('btnq-answered');
                        $(`#q_${item.id}${item[key]}${key}`).prop(
                          'checked',
                          true
                        );
                      }, 1000);
                    }
                  });
                });
                dispatch(setArrAnswerPart2(transformedArray));
              }

              // Chống mất đáp án phần 3
              let arrAnswerPart3 = response.data.data.questions
                ?.slice(16, 22)
                .map((question) => ({
                  key: question.id,
                  value: question.answerOfStudent
                }));
              dispatch(setArrAnswerPart3(arrAnswerPart3));

              // ExamStatusQuaHan         = 20 // Qua han lam bai
              // ExamStatusThiNgay        = 21 // Thi ngay  => gv hiển thị thông báo "Chưa thi"
              // ExamStatusChuanBiMo      = 22 // Chuan bi mo
              // ExamStatusDaNopBai       = 23 // Da nop bai
              // ExamStatusLienHeGiaoVien = 24 // Lien he giao vien khi có gian lận
              // ExamStatusDangLamBai     = 25 //  Dang lam bai
              // ExamStatusQuaHanNopBai   = 26 // Qua han nop bai

              setCurStatus(response.data.data.exam.cur_status);
              var msg = '';
              switch (response.data.data.exam.cur_status) {
                case 20:
                  msg =
                    'Quá hạn làm bài. Vui lòng liên hệ giáo viên để được hổ trợ.';
                  break;
                case 22:
                  msg = 'Bài thi sắp mở. Vui lòng quay lại phòng thi.';
                  break;
                case 23:
                  window.location.href = `/xem-ket-qua-2025?id=${gid_applyId}`;
                  msg =
                    'Bài thi đã nộp. Vui lòng liên hệ giáo viên để được hổ trợ.';
                  break;
                case 24:
                  msg =
                    'Bài thi bị khóa. Vui lòng liên hệ giáo viên để được hổ trợ.';
                  break;
                // case 26: // bổ sung 1/8 => cho thi tiếp
                //   msg="Quá hạn nộp bài. Vui lòng liên hệ giáo viên để được hổ trợ.";
                //   break;
                case 101:
                  msg =
                    'Hành vi bất thường. Vui lòng liên hệ giáo viên để được hổ trợ.';
                  break;
                default:
                  break;
              }
              if (
                response.data.data.exam.cur_status == 20 ||
                response.data.data.exam.cur_status == 22 ||
                response.data.data.exam.cur_status == 23 ||
                response.data.data.exam.cur_status == 24 ||
                response.data.data.exam.cur_status == 26 ||
                response.data.data.exam.cur_status == 101
              ) {
                //flag => stop here
                statusExam.current = true;
                swal({
                  text: msg,
                  icon: 'warning',
                  buttons: true,
                  dangerMode: true
                }).then((willDelete) => {
                  window.location.href = '/de-thi-can-lam';
                });
              }

              //dang de
              questionTypeId.current = response.data.data.exam.question_type_id;
              if (questionTypeId.current <= 0) {
                //flag => stop here
                statusExam.current = true;
                swal({
                  text: 'Định dạng bài thi không đúng. Vui lòng liên hệ giáo viên để được hổ trợ.',
                  icon: 'warning',
                  buttons: true,
                  dangerMode: true
                }).then((willDelete) => {
                  window.location.href = '/de-thi-can-lam';
                });
              }
              setQuestionArr(response.data.data.questions);
              //totalQuestion = response.data.data.questions.length;

              // setFirstArray(response.data.data.questions.slice(0, 12))
              // setSecondArray(response.data.data.questions.slice(12, 16))
              // setThirdArray(response.data.data.questions.slice(16, 22))
              //// de thpt 2025
              // 1 Toán
              if (response.data.data.exam.subject_id === 1) {
                // Tổng số câu hỏi theo đề thi 2025
                //totalQuestion = 34;
                // const dividePart = divideSubjectType1(response.data.data.questions);
                // const { part1, part2, part3 } = dividePart;
                // setFirstArray(part1);
                // setSecondArray(part2);
                // setThirdArray(part3);
              } else if (
                // 6 Lý, 7 Hóa, 9 Sinh, 11 Địa
                response.data.data.exam.subject_id === 6 ||
                response.data.data.exam.subject_id === 7 ||
                response.data.data.exam.subject_id === 9 ||
                response.data.data.exam.subject_id === 11
              ) {
                // Tổng số câu hỏi theo đề thi 2025
                //totalQuestion = 40;
                // const dividePart = divideSubjectType2(response.data.data.questions);
                // const { part1, part2, part3 } = dividePart;
                // setFirstArray(part1);
                // setSecondArray(part2);
                // setThirdArray(part3);
              } else if (
                // 10 Sử, 12 GDCD, 15 [CN công nghiệp, CN nông nghiệp], 31 Giáo dục kinh tế & Pháp luật
                response.data.data.exam.subject_id === 10 ||
                response.data.data.exam.subject_id === 12 ||
                response.data.data.exam.subject_id === 15 ||
                response.data.data.exam.subject_id === 31
              ) {
                // Tổng số câu hỏi theo đề thi 2025
                //totalQuestion = 40;
                // const dividePart = divideSubjectType3(response.data.data.questions);
                // const { part1, part2 } = dividePart;
                // setFirstArray(part1);
                // setSecondArray(part2);
              } else if (
                // 8 Anh
                response.data.data.exam.subject_id === 8
              ) {
                // Tổng số câu hỏi theo đề thi 2025
                //totalQuestion = 40;
                // const dividePart = divideSubjectType4(response.data.data.questions);
                // const { part1 } = dividePart;
                // setFirstArray(part1);
              } else if (
                // 14 Tin
                response.data.data.exam.subject_id === 14
              ) {
                // Tổng số câu hỏi theo đề thi 2025
                //totalQuestion = 40; // chọn phần, 2 phần mỗi phần 2 câu, chọn 1 phần (8 câu )
                // const dividePart = divideSubjectType5(response.data.data.questions);
                // const { part1, part2 } = dividePart;
                // setFirstArray(part1);
                // setSecondArray(part2);

                //const divideSubPart = divideSubjectType5SubPart(part2);
                const divideSubPart = divideSubjectType5SubPart(
                  response.data.data.questions.filter(
                    (x) => x.sub_question_type_id == 2
                  )
                );
                const { subPart1, subPart2, subPart3 } = divideSubPart;
                setFirstArraySubPart(subPart1);
                setSecondArraySubPart(subPart2);
                setThirdArraySubPart(subPart3);

                // loai phan rieng: 1: dinh huong khoa hoc may tinh, 2: dinh huong tin hoc ung dung
                //setOrientationType(response.data.data.exam.orientation_type);
                orientationType.current =
                  response.data.data.exam.orientation_type;
              }

              setFirstArray(
                response.data.data.questions.filter(
                  (x) => x.sub_question_type_id == 1
                )
              );
              setSecondArray(
                response.data.data.questions.filter(
                  (x) => x.sub_question_type_id == 2
                )
              );
              setThirdArray(
                response.data.data.questions.filter(
                  (x) => x.sub_question_type_id == 3
                )
              );

              setQuestions(response.data.data.questions);
              response.data.data.questions.forEach((question, num) => {
                assignArr += `${question.id};`;
              });
              setAssignArrNext(assignArr);

              // get info
              setExamRecordId(response.data.data.exam.last_exam_record_id);
              setGID(response.data.data.exam.gid);
              examRecordIdCurrent.current =
                response.data.data.exam.last_exam_record_id;
              gidCurrent.current = response.data.data.exam.gid;
              setSchoolname(response.data.data.exam.school_name);
              setRoomname(response.data.data.exam.room_name);
              setExamname(response.data.data.exam.exam_name);
              setSubjectname(response.data.data.exam.subject_name);
              setUsername(response.data.data.exam.student_name);
              subjectId.current = response.data.data.exam.subject_id;
              isFree.current = response.data.data.exam?.is_free;

              numOfQuestion = response.data.data.questions.length;
              // totalQuestion = response.data.data.questions.length;
              // // Tổng số câu hỏi theo đề thi 2025
              // if (response.data.data.exam.question_type_id == 4) {
              //   if (response.data.data.exam.subject_id == 1) { // môn Toán
              //     totalQuestion = 34;
              //   }
              // }

              duration =
                response.data.data.exam.settings.duration_in_seconds / 60;
              //currentMunute = (response.data.data.exam.settings.duration_in_seconds)/60 - 1;
              totalDuration =
                response.data.data.exam.settings.duration_in_seconds / 60;

              //on/off cheating
              offCheating.current =
                response.data.data.exam.settings.off_cheating;

              //tracking
              //var tracking_data =   cookies.get(gid_applyId);
              var tracking_data = null; //  window.localStorage.getItem(gid_applyId); // tam off tu store

              if (tracking_data != null) {
                tracking_data = Base64.decode(tracking_data);
                var trkSplit = tracking_data.split('|');
                if (queryParams[0].split('=')[1] == trkSplit[0]) {
                  spendTime = trkSplit[3]; // time
                  var answer_result = JSON.parse(trkSplit[4]);
                  setQuestionsData(answer_result); // answers
                  //var freshNum_data = trkSplit[5]; // freshNum
                  // var outExam_data = trkSplit[6]; // outExam

                  // assign answer from store
                  response.data.data.questions.forEach((question, num) => {
                    answer_result.forEach((q) => {
                      if (question.id == q.id) {
                        response.data.data.questions[num].answerOfStudent =
                          q.answerOfStudent;
                        response.data.data.questions[num].isAnswered =
                          q.isAnswered;
                        if (questionTypeId.current == 3) {
                          // gang tam =0  => =3

                          response.data.data.questions[num].answerImages =
                            q.answerImages.split(',');
                          response.data.data.questions[num].answerFiles =
                            q.answerFiles.split(',');
                          response.data.data.questions[
                            num
                          ].answerOfStudentImages = q.answerImages;
                          response.data.data.questions[
                            num
                          ].answerOfStudentFiles = q.answerFiles;
                        }
                      }
                    });
                  });
                  setQuestions(response.data.data.questions);
                }
              } else {
                // get api

                response.data.data.questions.forEach((question, num) => {
                  if (questionTypeId.current == 3) {
                    // gang tam =0  => =3
                    if (
                      response.data.data.exam.result != null &&
                      response.data.data.exam.result != undefined
                    ) {
                      if (
                        response.data.data.exam.result[
                          examRecordIdCurrent.current
                        ] != null ||
                        response.data.data.exam.result[
                          examRecordIdCurrent.current
                        ] != undefined
                      ) {
                        // gang tam =0  => =3
                        var answerImages =
                          response.data.data.exam.result[
                            examRecordIdCurrent.current
                          ][question.id + '_images'];
                        var answerFiles =
                          response.data.data.exam.result[
                            examRecordIdCurrent.current
                          ][question.id + '_files'];

                        response.data.data.questions[num].answerImages =
                          answerImages.split(',');
                        response.data.data.questions[num].answerFiles =
                          answerFiles.split(',');
                        response.data.data.questions[
                          num
                        ].answerOfStudentImages = answerImages;
                        response.data.data.questions[num].answerOfStudentFiles =
                          answerFiles;
                      }
                    } else {
                      response.data.data.questions[num].answerImages = [];
                      response.data.data.questions[num].answerFiles = [];
                      response.data.data.questions[num].answerOfStudentImages =
                        '';
                      response.data.data.questions[num].answerOfStudentFiles =
                        '';
                    }
                  }
                });
                setQuestions(response.data.data.questions);
              }

              if (spendTime > 0) {
                // store
                spendTime = spendTime;
              } else if (
                response.data.data.exam.spend_time > 0 &&
                response.data.data.exam.spend_time <=
                  response.data.data.exam.settings.duration_in_seconds
              ) {
                spendTime = response.data.data.exam.spend_time;
              } else if (response.data.data.exam.spend_time < 0) {
                spendTime =
                  response.data.data.exam.settings.duration_in_seconds; // reset time = 1p => time out
              }

              currentMunute = duration - 1 - parseInt(spendTime / 60);
              if (currentMunute < 0) {
                // time minute < 0
                currentMunute = 1;
              }

              //spendTime = (60 - (parseInt(spendTime) % 60))
              current = 60 - (parseInt(spendTime) % 60);
              if (currentMunute < 0) {
                current = 0;
              }

              ///
              setDurations(duration);
              setTotalDurations(totalDuration);
              totalDurationsCurr.current = totalDuration;
              setCurrentMunutes(currentMunute);
              setCurrentSeconds(current);
              setNumOfQuestions(numOfQuestion);
              setTotalQuestions(totalQuestion);
              // spendTime = response.data.data.exam.settings.spendTime;
              // refeshNum = response.data.data.exam.settings.refeshNum;
              // outExam = response.data.data.exam.settings.outExam;
              // refeshNum = response.data.data.exam.settings.refeshNum;
              // outExam = response.data.data.exam.settings.outExam;
            } else if (response == undefined) {
              config.hideLoader();
              setQuestions([]);
              swal('', 'Bài thi không đúng. Vui lòng kiểm tra lại', 'warning', {
                button: 'OK'
              });
              statusExam.current = true;
              return false;
            } else {
              config.hideLoader();
              statusExam.current = true;
              return false;
            }
          })
          .catch(function (error) {
            config.hideLoader();
          });
      }

      // init countdown
      setTimeout(function () {
        //currentMunute--;
        $('#submitCountdownModal').click();
        if (statusExam.current == true) {
          return false;
        }
        countDown();
      }, parseInt(process.env.REACT_APP_COUNTDOWN_EXAM));

      setInterval(async function () {
        var status1 = navigator.onLine;
        if (status1 == false) {
          $('#showhidestatusonline').show();
        } else {
          if (status1 == true) {
            $('#showhidestatusonline').hide();
          }
        }
        //setStatusOnline(status1);
      }, 10000); // 10s

      // off public... script.js =>off menu
      if ($(window).width() < 768) {
        $('body').removeClass('menu-active');
      }

      $(document).keydown(function (e) {
        if (
          e.ctrlKey ||
          e.altKey ||
          e.keyCode == 112 ||
          e.keyCode == 113 ||
          e.keyCode == 114 ||
          e.keyCode == 115 ||
          e.keyCode == 116 ||
          e.keyCode == 117 ||
          e.keyCode == 118 ||
          e.keyCode == 119 ||
          e.keyCode == 120 ||
          e.keyCode == 121 ||
          e.keyCode == 122 ||
          e.keyCode == 123 ||
          e.keyCode == 16 ||
          e.keyCode == 36 ||
          e.keyCode == 19
        ) {
          // e.keyCode == 9 => phim tab, 16: shift, 36 home, 19 pause/break
          return false;
        }
      });

      $('body').bind('cut copy paste', function (e) {
        e.preventDefault();
      });

      // not right click
      $(document).bind('contextmenu', function () {
        return false;
      });
    })();
  }, []);

  const location = useLocation();
  // useEffect(() => {
  //   const preventBackNavigation = () => {
  //     window.history.pushState(null, "", window.location.href);
  //   };

  //   // Chặn Back Button
  //   window.history.pushState(null, "", window.location.href);
  //   window.addEventListener("popstate", preventBackNavigation);

  //   return () => {
  //     // Gỡ bỏ sự kiện khi component unmount
  //     window.removeEventListener("popstate", preventBackNavigation);
  //   };
  // }, [location.pathname]);

  const handleChange = (event) => {
    event.persist();

    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const stopEndTime = 0;
  function countDown() {
    if (statusExam.current == true) {
      return;
    } // stop here
    setTimeout(function () {
      if (disconnectNum <= 60) {
        if (document.cookie.indexOf('noblur') == -1) {
          current--;
        }
      }
      if (current >= 0) {
        $('#countDownTimeSeconds').html(getTime(current));
        countDown();
      } else {
        if (currentMunute > 0) {
          currentMunute = $('#countDownTimeMunute').text();
          currentMunute--;
          current = 59;

          $('#countDownTimeSeconds').html(getTime(current));
          $('#countDownTimeMunute').html(getTime(currentMunute));
          countDown();
        } else {
          var status = navigator.onLine;
          if (status == false) {
            stopEndTime = 1;
            swal(
              '',
              'Đường truyền mạng không ổn định. Bạn vui lòng liên hệ giáo viên để được hổ trợ. Nếu hết thời gian làm bài, vui lòng đợi 5 phút khi có mạng lại hệ thống sẽ tự động nộp bài.',
              'warning',
              {
                button: 'OK'
              }
            );

            setTimeout(function () {
              autoSaveTest(1);
              disconnectNum += 1;
              //setDisconnectNum(disconnectNum);
            }, 5000);
          } else {
            // hết thời gian
            autoSaveTest(1); // thời gian 30s sẽ tự động submit nếu không nộp
          }
        }
      }
    }, 1000);
  }

  function getTime(s) {
    if (s > 9) {
      return s;
    }
    return `0${s}`;
  }
  // end countdown

  // làm việc ngoài
  let timeCurrent = 5; // 15s làm việc ngoài => 3s làm việc ngoài
  let cClearTime;
  let cClearTime1;
  // beforeunload => close tab

  // kiem tra dau tien vao trang noblur
  //if (process.env.REACT_APP_ENABLEINFO == "1" && questionTypeId.current == 4) {
  if (!offCheating.current && questionTypeId.current == 4) {
    if (document.cookie.indexOf('noblur') != -1) {
      // exists
      autoSaveTest(2); // outexam
      cClearTime1 = setInterval(function () {
        swal({
          text: 'Vui lòng liên hệ giáo viên để được cấp quyền thi lại vì bạn đã làm việc riêng trong thời gian làm bài.',
          icon: 'warning',
          buttons: ['Đóng', 'Liên hệ'],
          dangerMode: true
        }).then((willDelete) => {
          ClearCookie();
          window.location.href = linkExam;
        });
        clearInterval(cClearTime1);
      }, 2000);
    }
  }

  function ClearCookie() {
    document.cookie =
      'showblur' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/';
    // document.cookie = "username=John Doe; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/";   // UTC + 7
  }
  // end làm việc ngoài

  // chọn cau hỏi add và remove class
  let currentQuestionId;
  let cTimeout;
  let cTimeoutBS;
  let toTimeout;
  let refreshIntervalId;

  function activeQuestion(event, qId, chkId) {
    if (qId == '' || qId == null) {
      return;
    }
    currentQuestionId = qId;
    $('.qItem').hide();
    $(`#questionRegionItem_${qId}`).show();
    $('.btnq').removeClass('btnq-active');
    $(`#q_btn_${qId}`).addClass('btnq-active');

    $(`#q_btn_${qId}a1`).addClass('btnq-active');
    $(`#quesItemPart2${qId}a1`).addClass('btnq-active');

    $(`#q_btn_${chkId}`).removeClass('active');
    $(`#q_btn_${chkId}`).addClass('active');
  }

  function next(event, nxt, nextOrPre, chkId) {
    // event.preventDefault();

    stt = 0; // check call double autoSaveTest
    nextOrPre = nxt;
    //qArr = assignArr.split(';');
    qArr = assignArrNext.split(';');
    let cIndex = qArr.indexOf(`${currentQuestionId}`);
    if (cIndex == -1) {
      cIndex = 0;
    }
    if (
      (nextOrPre == -1 && cIndex == 0) ||
      (nextOrPre == 1 && cIndex == qArr.length - 1)
    ) {
      return;
    }
    activeQuestion(event, qArr[cIndex + nextOrPre], chkId);
  }
  var stt = 0; // check double
  function checkItem(event, qId, chkId) {
    if (stt == 1) {
      stt = 0;
      return;
    }
    // event.preventDefault();  // run click input=>ok, click label call double
    if (statusExam.current == true) {
      return;
    } // stop here
    //chkId = this;
    $(`#q_btn_${chkId}`).addClass('btnq-answered');
    $(`.chk_q_${chkId}`).prop('checked', false);
    $(`#${qId}`).prop('checked', true);
    $(`#hidden_${chkId}`).val($(`#${qId}`).val());
    $(`#q_btn_${chkId}`).addClass('active');

    clearTimeout(cTimeout);
    clearInterval(refreshIntervalId); // save store
    //if (questionTypeId.current == 4) {
    cTimeout = setTimeout(function () {
      next(event, 1, qArr, chkId);
    }, 1000);
    //}

    autoSaveTest(0, chkId, $(`#${qId}`).val(), 'checkItem');
    stt += 1;
  }

  var sttnextpart3 = 0; // check double
  function checkItemNextPart3(event, qId, chkId) {
    //if (sttnextpart3 == 1) { sttnextpart3 = 0; return; }
    if (statusExam.current == true) {
      return;
    } // stop here
    //chkId = this;
    if ($(`#hidden_${chkId}`).val() == '') {
      return false;
    }
    ////lưu và tiếp theo
    $(`#q_btn_${chkId}`).addClass('btnq-answered');
    $(`#q_btn_${chkId}`).addClass('active');
    // end lưu và tiếp theo

    clearTimeout(cTimeout);
    clearInterval(refreshIntervalId); // save store
    cTimeout = setTimeout(function () {
      next(event, 1, qArr, chkId);
    }, 300);
    autoSaveTest(0, chkId, $(`#hidden_${chkId}`).val(), 'checkItem');
    //sttnextpart3 += 1;
  }

  function checkItemNextPart2(event, qId, chkId) {
    if (statusExam.current == true) {
      return;
    } // stop here

    // set active a1
    addClassPart2(event, chkId, 'a1');

    $(`#q_btn_${chkId}`).addClass('btnq-answered');
    $(`#q_btn_${chkId}`).addClass('active');

    clearTimeout(cTimeout);
    clearInterval(refreshIntervalId); // save store
    cTimeout = setTimeout(function () {
      next(event, 1, qArr, chkId);
    }, 300);
  }

  let answerPart2PrevNew = [...answerPart2Prev];
  function checkItemPart2(
    event,
    qId,
    chkId,
    optionPart2,
    orientation_type = 0
  ) {
    // if (stt %2 == 1) { stt = 0; return; }
    if (statusExam.current == true) {
      return;
    } // stop here
    const arrQuestionId = secondArray.map((question) => question.id);
    const answerOption = $(`#${qId}`).val();

    /*
    let answerPart2;
    switch (chkId) {
      case arrQuestionId[0]:
        answerPart2 = answerPart2Ques1;
        break;
      case arrQuestionId[1]:
        answerPart2 = answerPart2Ques2;
        break;
      case arrQuestionId[2]:
        answerPart2 = answerPart2Ques3;
        break;
      case arrQuestionId[3]:
        answerPart2 = answerPart2Ques4;
        break;
      case arrQuestionId[4]:
        answerPart2 = answerPart2Ques5;
        break;
      case arrQuestionId[5]:
        answerPart2 = answerPart2Ques6;
        break;
      case arrQuestionId[6]:
        answerPart2 = answerPart2Ques7;
        break;
      case arrQuestionId[7]:
        answerPart2 = answerPart2Ques8;
        break;
      case arrQuestionId[8]:
        answerPart2 = answerPart2Ques9;
        break;
      case arrQuestionId[9]:
        answerPart2 = answerPart2Ques10;
        break;
      case arrQuestionId[10]:
        answerPart2 = answerPart2Ques11;
        break;
      case arrQuestionId[11]:
        answerPart2 = answerPart2Ques12;
        break;
      case arrQuestionId[12]:
        answerPart2 = answerPart2Ques13;
        break;
      case arrQuestionId[13]:
        answerPart2 = answerPart2Ques14;
        break;
      case arrQuestionId[14]:
        answerPart2 = answerPart2Ques15;
        break;
      case arrQuestionId[15]:
        answerPart2 = answerPart2Ques16;
        break;
      case arrQuestionId[16]:
        answerPart2 = answerPart2Ques17;
        break;
      case arrQuestionId[17]:
        answerPart2 = answerPart2Ques18;
        break;
      case arrQuestionId[18]:
        answerPart2 = answerPart2Ques19;
        break;
      case arrQuestionId[19]:
        answerPart2 = answerPart2Ques20;
        break;
      case arrQuestionId[20]:
        answerPart2 = answerPart2Ques21;
        break;
      case arrQuestionId[21]:
        answerPart2 = answerPart2Ques22;
        break;
      case arrQuestionId[22]:
        answerPart2 = answerPart2Ques23;
        break;
      case arrQuestionId[23]:
        answerPart2 = answerPart2Ques24;
        break;
      case arrQuestionId[24]:
        answerPart2 = answerPart2Ques25;
        break;
      case arrQuestionId[25]:
        answerPart2 = answerPart2Ques26;
        break;
      case arrQuestionId[26]:
        answerPart2 = answerPart2Ques27;
        break;
      case arrQuestionId[27]:
        answerPart2 = answerPart2Ques28;
        break;
      case arrQuestionId[28]:
        answerPart2 = answerPart2Ques29;
        break;
      case arrQuestionId[29]:
        answerPart2 = answerPart2Ques30;
        break;
      case arrQuestionId[30]:
        answerPart2 = answerPart2Ques31;
        break;
      case arrQuestionId[31]:
        answerPart2 = answerPart2Ques32;
        break;
      case arrQuestionId[32]:
        answerPart2 = answerPart2Ques33;
        break;
      case arrQuestionId[33]:
        answerPart2 = answerPart2Ques34;
        break;
      case arrQuestionId[34]:
        answerPart2 = answerPart2Ques35;
        break;
      case arrQuestionId[35]:
        answerPart2 = answerPart2Ques36;
        break;
      case arrQuestionId[36]:
        answerPart2 = answerPart2Ques37;
        break;
      case arrQuestionId[37]:
        answerPart2 = answerPart2Ques38;
        break;  
      case arrQuestionId[38]:
        answerPart2 = answerPart2Ques39;
        break; 
      case arrQuestionId[39]:
        answerPart2 = answerPart2Ques40;
        break; 
      case arrQuestionId[40]:
        answerPart2 = answerPart2Ques41;
        break; 
      case arrQuestionId[41]:
        answerPart2 = answerPart2Ques42;
        break; 
      case arrQuestionId[42]:
        answerPart2 = answerPart2Ques43;
        break; 
      case arrQuestionId[43]:
        answerPart2 = answerPart2Ques44;
        break; 
      case arrQuestionId[44]:
        answerPart2 = answerPart2Ques45;
        break; 
      case arrQuestionId[45]:
        answerPart2 = answerPart2Ques46;
        break; 
      case arrQuestionId[46]:
        answerPart2 = answerPart2Ques47;
        break; 
      case arrQuestionId[47]:
        answerPart2 = answerPart2Ques48;
        break; 
      case arrQuestionId[48]:
        answerPart2 = answerPart2Ques49;
        break; 
      case arrQuestionId[49]:
        answerPart2 = answerPart2Ques50;
        break; 
      default:
        console.log("Không có câu hỏi tương ứng.");
        return;
    }

    // Cập nhật chuỗi answerPart2 dựa trên optionPart2 và answerOption
    let optionExists = false;
    const newAnswerPart2 = answerPart2.split(/(?=a[1-4])/).map(part => {
      if (part.startsWith(optionPart2)) {
        optionExists = true;
        return `${optionPart2}${answerOption}`;
      }
      return part;
    }).join("");

    // Nếu optionPart2 chưa tồn tại, thêm mới vào cuối chuỗi
    if (!optionExists) {
      answerPart2 += `${optionPart2}${answerOption}`;
    } else {
      answerPart2 = newAnswerPart2;
    }

    // Gán giá trị mới lại cho biến toàn cục tương ứng
    switch (chkId) {
      case arrQuestionId[0]:
        answerPart2Ques1 = answerPart2;
        break;
      case arrQuestionId[1]:
        answerPart2Ques2 = answerPart2;
        break;
      case arrQuestionId[2]:
        answerPart2Ques3 = answerPart2;
        break;
      case arrQuestionId[3]:
        answerPart2Ques4 = answerPart2;
        break;
      case arrQuestionId[4]:
        answerPart2Ques5 = answerPart2;
        break;
      case arrQuestionId[5]:
        answerPart2Ques6 = answerPart2;
        break;
      case arrQuestionId[6]:
        answerPart2Ques7 = answerPart2;
        break;
      case arrQuestionId[7]:
        answerPart2Ques8 = answerPart2;
        break;
      case arrQuestionId[8]:
        answerPart2Ques9 = answerPart2;
        break;
      case arrQuestionId[9]:
        answerPart2Ques10 = answerPart2;
        break;
      case arrQuestionId[10]:
        answerPart2Ques11 = answerPart2;
        break;
      case arrQuestionId[11]:
        answerPart2Ques12 = answerPart2;
        break;
      case arrQuestionId[12]:
        answerPart2Ques13 = answerPart2;
        break;
      case arrQuestionId[13]:
        answerPart2Ques14 = answerPart2;
        break;
      case arrQuestionId[14]:
        answerPart2Ques15 = answerPart2;
        break;
      case arrQuestionId[15]:
        answerPart2Ques16 = answerPart2;
        break;
      case arrQuestionId[16]:
        answerPart2Ques17 = answerPart2;
        break;
      case arrQuestionId[17]:
        answerPart2Ques18 = answerPart2;
        break;
      case arrQuestionId[18]:
        answerPart2Ques19 = answerPart2;
        break;
      case arrQuestionId[19]:
        answerPart2Ques20 = answerPart2;
        break;
      case arrQuestionId[20]:
        answerPart2Ques21 = answerPart2;
        break;
      case arrQuestionId[21]:
        answerPart2Ques22 = answerPart2;
        break;
      case arrQuestionId[22]:
        answerPart2Ques23 = answerPart2;
        break;
      case arrQuestionId[23]:
        answerPart2Ques24 = answerPart2;
        break;
      case arrQuestionId[24]:
        answerPart2Ques25 = answerPart2;
        break;
      case arrQuestionId[25]:
        answerPart2Ques26 = answerPart2;
        break;
      case arrQuestionId[26]:
        answerPart2Ques27 = answerPart2;
        break;
      case arrQuestionId[27]:
        answerPart2Ques28 = answerPart2;
        break;
      case arrQuestionId[28]:
        answerPart2Ques29 = answerPart2;
        break;
      case arrQuestionId[29]:
        answerPart2Ques30 = answerPart2;
        break;
      case arrQuestionId[30]:
        answerPart2Ques31 = answerPart2;
        break;
      case arrQuestionId[31]:
        answerPart2Ques32 = answerPart2;
        break;
      case arrQuestionId[32]:
        answerPart2Ques33 = answerPart2;
        break;
      case arrQuestionId[33]:
        answerPart2Ques34 = answerPart2;
        break;
      case arrQuestionId[34]:
        answerPart2Ques35 = answerPart2;
        break;
      case arrQuestionId[35]:
        answerPart2Ques36 = answerPart2;
        break;
      case arrQuestionId[36]:
        answerPart2Ques37 = answerPart2;
        break;
      case arrQuestionId[37]:
        answerPart2Ques38 = answerPart2;
        break;
      case arrQuestionId[38]:
        answerPart2Ques39 = answerPart2;
        break;
      case arrQuestionId[39]:
        answerPart2Ques40 = answerPart2;
        break;
      case arrQuestionId[40]:
        answerPart2Ques41= answerPart2;
        break;
      case arrQuestionId[41]:
        answerPart2Ques42 = answerPart2;
        break;
      case arrQuestionId[42]:
        answerPart2Ques43 = answerPart2;
        break;
      case arrQuestionId[43]:
        answerPart2Ques44 = answerPart2;
        break;
      case arrQuestionId[44]:
        answerPart2Ques45 = answerPart2;
        break;
      case arrQuestionId[45]:
        answerPart2Ques46 = answerPart2;
        break;
      case arrQuestionId[46]:
        answerPart2Ques47 = answerPart2;
        break;
      case arrQuestionId[47]:
        answerPart2Ques48 = answerPart2;
        break;
      case arrQuestionId[48]:
        answerPart2Ques49 = answerPart2;
        break;
      case arrQuestionId[49]:
        answerPart2Ques50 = answerPart2;
        break;
    }  */

    //////////////gon lai code////////////////
    // Giả sử các câu trả lời được lưu trong mảng

    let answers = [...answerPart2PrevNew];
    // Lấy giá trị answerPart2 từ mảng
    let answerPart2;
    const index = arrQuestionId.indexOf(chkId);
    if (index !== -1) {
      answerPart2 = answers[index]?.answer || '';

      // Cập nhật chuỗi answerPart2 dựa trên optionPart2 và answerOption
      let optionExists = false;
      const newAnswerPart2 = answerPart2
        .split(/(?=a[1-4])/)
        .map((part) => {
          if (part.startsWith(optionPart2)) {
            optionExists = true;
            return `${optionPart2}${answerOption}`;
          }
          return part;
        })
        .join('');

      // Nếu optionPart2 chưa tồn tại, thêm mới vào cuối chuỗi
      if (!optionExists) {
        answerPart2 += `${optionPart2}${answerOption}`;
      } else {
        answerPart2 = newAnswerPart2;
      }

      // Gán giá trị mới lại vào mảng
      answers[index] = { id: answers[index].id, answer: answerPart2 };
      answerPart2PrevNew[index] = {
        id: answers[index].id,
        answer: answerPart2
      };
    } else {
      console.log('Không có câu hỏi tương ứng.');
    }
    //////////////////////////////////////////

    $(`#q_btn_${chkId}${optionPart2}`).addClass('btnq-answered');
    $(`.chk_q_${chkId}`).prop('checked', false);
    $(`#${qId}${optionPart2}`).prop('checked', true);

    $(`#q_btn_${chkId}${optionPart2}`).addClass('active');
    clearTimeout(cTimeout);
    clearInterval(refreshIntervalId);

    let obj = {
      a1: '',
      a2: '',
      a3: '',
      a4: ''
    };
    const validKeys = ['a1', 'a2', 'a3', 'a4'];

    let transPart2 = seperatePart2(answerPart2);

    answerPart2Prev?.forEach((object) => {
      if (object.id == chkId) {
        // Tách chuỗi đáp án trước khi reload
        let ansTrans = seperatePart2(object.answer);
        for (let k1 in ansTrans) {
          if (validKeys.includes(k1)) {
            obj[k1] = ansTrans[k1];
          }
        }
        for (let key2 in transPart2) {
          if (validKeys.includes(key2)) {
            obj[key2] = transPart2[key2];
          }
        }
      }
    });
    const result = formatObjectToString(obj);
    $(`#hidden_${chkId}`).val(result);

    /* Rieng cho mon tin hoc
      Chọn phần riêng, thì gọi api tracking_test lun, với action = "orientation_type"
      answer = "1" hoặc "2" ==> 1 là chọn khoa học máy tính, 2 là tin học ứng dụng
    */
    autoSaveTest(0, chkId, result, 'checkItem');
    stt += 1;

    if (
      subjectId.current == 14 &&
      (orientation_type == 1 || orientation_type == 2)
    ) {
      //setOrientationType(orientation_type);
      orientationType.current = orientation_type;
      //TrackingTestOrientation(orientation_type);
    }
  }

  // $('.input-textarea').on('keypress', function (e) {
  //   const currentValue = $(this).val();
  //   const key = e.key;

  //   // Allow digits and only one decimal point
  //   if (!/[0-9,]/.test(key) || (key === '.' && currentValue.includes('.'))) {
  //     e.preventDefault();
  //   }
  // });

  //$('.input-textarea').keypress(function(e) {
  // $('.input-textarea').on('keydown', function (e) {
  //   // var a = [];
  //   // var k = e.which;

  //   // for (var i = 44; i < 58; i++)
  //   // {
  //   //   if (i !== 45 && i !== 46 && i !== 47) {
  //   //     a.push(i);
  //   //   }
  //   //   //a.push(i);
  //   // }

  //   $(this).val($(this).val().replace(/[^0-9,]/g, ''));

  //   // if (!(a.indexOf(k) >= 0)) {
  //   //   e.preventDefault();
  //   // }

  // });

  // $('.input-textarea').on('input', function (e) {
  //   var value = $(this).val();
  //   var newValue = value.replace(/[^0-9,]/g, ''); // Loại bỏ tất cả các ký tự không phải số
  //   if (value !== newValue) {
  //   $(this).val(newValue);
  //   }
  // });

  // $('.input-textarea').keypress(function(e) {
  //     var a = [];
  //     var k = e.which;
  //     // 45: dấu trừ, 46: dấu chấm, 47: dấu chia /
  //     for (var i = 44; i < 58; i++)
  //     {
  //       if (i !== 45 && i !== 46 && i !== 47) {
  //         a.push(i);
  //       }
  //       //a.push(i);
  //     }

  //     if (!(a.indexOf(k)>=0))
  //         e.preventDefault();
  // });

  function checkItemCK(qId, chkId, vl, typeUpload = 1) {
    if (statusExam.current == true) {
      return;
    } // stop here
    vl = String(vl.replace(/<\/?p>/g, ''));
    // Chỉ cho phép các ký tự số
    // const regex = /^[0-9]*$/;
    // if (regex.test(vl)) {
    //   // là số
    // }

    $(`#q_btn_${chkId}`).addClass('btnq-answered');
    $(`.chk_q_${chkId}`).prop('checked', false);
    $(`#${qId}`).prop('checked', true);
    // $(`#hidden_${chkId}`).val($(`#${qId}`).val());
    if (typeUpload == 1) {
      $(`#hidden_${chkId}`).val(vl);
    }
    if (typeUpload == 2) {
      // textarea
      vl = $(`#${qId}`).val();
      $(`#hidden_${chkId}`).val(vl);
    }
    $(`#q_btn_${chkId}`).addClass('active');
    clearTimeout(cTimeout);
    clearInterval(refreshIntervalId); // save store
    cTimeout = setTimeout(function () {
      vl = $(`#hidden_${chkId}`).val();
      checkItemCK(qId, chkId, vl, 1);
    }, 30000);
    autoSaveTest(0, chkId, vl, 'checkItem');
    if (!vl) {
      $(`#q_btn_${chkId}`).removeClass('btnq-answered');
      $(`#q_btn_${chkId}`).removeClass('active');
    }
  }

  function addClass(event, qId) {
    //qId = this;
    let elements = `#q_btn_${qId}`;
    const myClass = 'btnq-active';

    // ///////////////
    currentQuestionId = qId;
    $('.qItem').hide();
    $('qItemPart2').hide();
    $(`#questionRegionItem_${qId}`).show();
    $('.btnq').removeClass('btnq-active');
    $(`#q_btn_${qId}`).addClass('btnq-active');
    // ///////////////

    // nếu ta có selector, nhận các elements đã chọn
    if (typeof elements === 'string') {
      elements = document.querySelectorAll(elements);
    }

    // nếu ta chỉ có một dom element, biến thành array để đơn giản hóa hành vi
    else if (!elements.length) {
      elements = [elements];
    }

    // thêm class vào tất cả element đã chọn
    for (let i = 0; i < elements.length; i++) {
      if (!` ${elements[i].className} `.indexOf(` ${myClass} `) > -1) {
        elements[i].className += ` ${myClass}`;
      }
    }
  }

  function checkOrientation(
    event,
    questionId,
    orientation_type = 0,
    orientation_type_disDiv = 0
  ) {
    //qId = this;
    if (orientation_type != 0) {
      //setOrientationType(orientation_type);
      orientationType.current = orientation_type;
    }

    TrackingTestOrientation(orientation_type);
    if (orientation_type_disDiv == 1) {
      $('.question-item').removeClass('disabledDiv');
      // $('#div-orientation-1').removeClass('disabledDiv');
      // $('#div-orientation-2').addClass('disabledDiv');

      $('.div-orientation-1').removeClass('disabledDiv');
      $('.div-orientation-2').addClass('disabledDiv');

      //$(`#tinhoc_${questionId}_1`).prop('checked', true);
    }
    if (orientation_type_disDiv == 2) {
      $('.answer').removeClass('disabledDiv');
      // $('#div-orientation-2').removeClass('disabledDiv');
      // $('#div-orientation-1').addClass('disabledDiv');
      $('.div-orientation-2').removeClass('disabledDiv');
      $('.div-orientation-1').addClass('disabledDiv');
    }
  }

  function addClassPart2(
    event,
    qId,
    ques,
    orientation_type = 0,
    orientation_type_disDiv = 0
  ) {
    if (orientation_type != 0) {
      //setOrientationType(orientation_type);
      orientationType.current = orientation_type;
    }

    if (orientation_type_disDiv == 1) {
      TrackingTestOrientation(orientation_type);
      $('.question-item').removeClass('disabledDiv');
      // $('#div-orientation-1').removeClass('disabledDiv');
      // $('#div-orientation-2').addClass('disabledDiv');

      $('.div-orientation-1').removeClass('disabledDiv');
      $('.div-orientation-2').addClass('disabledDiv');

      //$(`#tinhoc_${questionId}_1`).prop('checked', true);
    }
    if (orientation_type_disDiv == 2) {
      TrackingTestOrientation(orientation_type);
      $('.answer').removeClass('disabledDiv');
      // $('#div-orientation-2').removeClass('disabledDiv');
      // $('#div-orientation-1').addClass('disabledDiv');
      $('.div-orientation-2').removeClass('disabledDiv');
      $('.div-orientation-1').addClass('disabledDiv');
    }

    let elements = `#q_btn_${qId}`;
    const myClass = 'btnq-active';

    // ///////////////
    currentQuestionId = qId;
    $('.qItem').hide();
    $(`#questionRegionItem_${qId}`).show();
    $('.btnq').removeClass('btnq-active');
    $(`#q_btn_${qId}${ques}`).addClass('btnq-active');
    ////////
    //$(`.qItemPart2-${qId}`).hide(); // off => show all a b c d
    $(`.qItemPart2-${qId}`).removeClass('btnq-active');
    $(`#quesItemPart2${qId}${ques}`).addClass('btnq-active');
    /////////

    $(`#quesItemPart2${qId}${ques}`).show();
    // ///////////////

    // nếu ta có selector, nhận các elements đã chọn
    if (typeof elements === 'string') {
      elements = document.querySelectorAll(elements);
    }

    // nếu ta chỉ có một dom element, biến thành array để đơn giản hóa hành vi
    else if (!elements.length) {
      elements = [elements];
    }

    // thêm class vào tất cả element đã chọn
    for (let i = 0; i < elements.length; i++) {
      if (!` ${elements[i].className} `.indexOf(` ${myClass} `) > -1) {
        elements[i].className += ` ${myClass}`;
      }
    }
  }

  //autosave store
  function autoSaveStore(gidStore, ckValueStore) {
    window.localStorage.setItem(gidStore, Base64.encode(ckValueStore));
  }

  // autosave
  async function autoSaveTest(
    finish,
    questionId = 0,
    answer = '',
    action = ''
  ) {
    if (statusExam.current == true) {
      return false;
    } // stop here
    const hid = $('#historyId').val();
    currentMunute = parseInt($('#countDownTimeMunute').text());
    current = parseInt($('#countDownTimeSeconds').text());
    const t = totalDurationsCurr.current * 60 - (currentMunute * 60 + current);

    var status = navigator.onLine;

    let outExame = 0;
    // hid == 0: hs chưa thi
    if (t <= 0) {
      swal('', 'Chưa hết thời gian xem đề. Vui lòng đợi vài giây.', 'warning', {
        button: 'OK'
      });
      //return false;
    }
    //if (t > totalDurations * 60 && finish != 1) {
    if (t > totalDurationsCurr.current * 60 && finish != 1) {
      return false;
    }

    // kiem tra hs làm việc riêng
    //if (process.env.REACT_APP_ENABLEINFO == "1" && questionTypeId.current == 4) {
    if (!offCheating.current && questionTypeId.current == 4) {
      if (document.cookie.indexOf('noblur') != -1) {
        //clearInterval(cTimeoutBS); // reset lại 30s khi check kq
        //clearTimeout(toTimeout);
        swal({
          text: 'Vui lòng liên hệ giáo viên để được cấp quyền thi lại vì bạn đã làm việc riêng trong thời gian làm bài.',
          icon: 'warning',
          buttons: ['Đóng', 'Liên hệ'],
          dangerMode: true
        }).then((willDelete) => {
          if (willDelete) {
            ClearCookie();
            window.location.href = linkExam;
          } else {
          }
        });
        return false;
      }
    }

    //if (process.env.REACT_APP_ENABLEINFO == "1") {
    if (!offCheating.current) {
      if (disconnectNum >= 60) {
        // save 5s 1 lan =>5p
        // 5p khong internet
        //statusExam.current = true; // stop here
        swal({
          text: 'Đường truyền mạng không ổn định liên tục trong 5 phút. Bạn vui lòng liên hệ giáo viên để được hổ trợ.',
          icon: 'warning',
          buttons: ['Đóng', 'Liên hệ'],
          dangerMode: true
        }).then((willDelete) => {
          if (willDelete) {
            //ClearCookie();
            window.location.href = linkExam;
          } else {
          }
        });
        return false;
      }
    }
    //////////////////////

    //var a = '';
    var answers = '';
    var answers_files = '';
    var answers_images = '';

    // var answers_files = [];
    // var answers_images = [];
    var answer_store = [];

    $('.hiddenQIDCSS').each(function () {
      var id = $(this).attr('data-id');
      //const answer = $(this).val();
      //var answer = $("#q_"+id).val();
      var a_images = $('#hidden_images_' + id).val();
      var a_files = $('#hidden_files_' + id).val();
      //a += `${id}_${answer}|`;
      if (questionTypeId.current == 4) {
        var answer1 = $(this).val(); // $("#q_"+id).val();
        answers += `"${id}":"${answer1}",`;

        answer_store.push({
          id: id,
          answerOfStudent: `${answer1}`,
          isRight: false,
          isAnswered: answer1 != '' ? true : false,
          answerImages: ``,
          answerFiles: ``
        });
      } else if (questionTypeId.current == 3) {
        // gang tam =0  => =3
        // re set value tuluan
        var answer1 = $('#hidden_' + id).val();
        //answer = $("#q_"+id).val();
        answers += `"${id}":"${answer1}",`;
        answers_images += `"${id}_images":"${_.split(a_images, ',')}",`;
        answers_files += `"${id}_files":"${_.split(a_files, ',')}",`;
        answer_store.push({
          id: id,
          answerOfStudent: `${answer1}`,
          isRight: false,
          isAnswered:
            answer1 != '' || a_images != '' || a_files != '' ? true : false,
          answerImages: `${a_images}`,
          answerFiles: `${a_files}`
        });
      }
    });

    //a = a.slice(0, a.length - 1);
    //answers = answers.slice(0, answers.length - 1);
    if (questionTypeId.current == 4) {
      answers = answers.slice(0, answers.length - 1);
    } else if (questionTypeId.current == 3) {
      // gang tam =0  => =3
      answers_files = answers_files.slice(0, answers_files.length - 1);
      answers = answers + answers_images + answers_files;
    }

    if (finish != 1) {
      if (finish == 2) {
        outExame = 1;
        action = 'LamViecRieng';

        //save store
        const ckValue1 = `${gidCurrent.current}|${examRecordIdCurrent.current}|${hid}|${t}|${JSON.stringify(answer_store)}|${refeshNum}|${outExam}`;
        window.localStorage.setItem(
          gidCurrent.current,
          Base64.encode(ckValue1)
        );
        TrackingTest(
          0,
          '',
          action,
          { outExam: outExame, refeshNum: refeshNum, finish: finish },
          answers,
          t
        );

        // if(questionTypeId.current == 4){
        //   if(subjectId.current == 14 && action == "orientation_type"){// (orientationType == 1 || orientationType == 2)){// mon tin
        //     TrackingTestOrientation(0, "", action, { outExam: outExame, refeshNum: refeshNum, finish: finish }, answers, t)
        //   } else
        //   {
        //     TrackingTest(0, "", action, { outExam: outExame, refeshNum: refeshNum, finish: finish }, answers, t);
        //   }
        // }
        // else
        // {
        //   TrackingTest(0, "", action, { outExam: outExame, refeshNum: refeshNum, finish: finish }, answers, t);
        // }
        ClearCookie();
        return false;
      }
    }

    const ckValue = `${gidCurrent.current}|${examRecordIdCurrent.current}|${hid}|${t}|${JSON.stringify(answer_store)}|${refeshNum}|${outExam}`;
    //cookies.set(gidCurrent.current, Base64.encode(ckValue), { path: '/' });
    window.localStorage.setItem(gidCurrent.current, Base64.encode(ckValue));

    refreshIntervalId = setInterval(function () {
      var currentMunuteStore = parseInt($('#countDownTimeMunute').text());
      var currentStore = parseInt($('#countDownTimeSeconds').text());
      const tStore =
        totalDurationsCurr.current * 60 -
        (currentMunuteStore * 60 + currentStore);
      var answer_store2 = [];
      // get data save store 5s
      if (questionTypeId.current == 4) {
        const ckValueStore = `${gidCurrent.current}|${examRecordIdCurrent.current}|${hid}|${tStore}|${JSON.stringify(answer_store)}|${refeshNum}|${outExam}`;
        autoSaveStore(gidCurrent.current, ckValueStore);
      } else if (questionTypeId.current == 3) {
        // gang tam =0  => =3
        var answers2 = '';
        var answers_files2 = '';
        var answers_images2 = '';
        $('.hiddenQIDCSS').each(function () {
          var id = $(this).attr('data-id');
          var a_images2 = $('#hidden_images_' + id).val();
          var a_files2 = $('#hidden_files_' + id).val();

          var answer2 = $('#hidden_' + id).val();
          answers2 += `"${id}":"${answer2}",`;
          answers_images2 += `"${id}_images":"${_.split(a_images2, ',')}",`;
          answers_files2 += `"${id}_files":"${_.split(a_files2, ',')}",`;
          answer_store2.push({
            id: id,
            answerOfStudent: `${answer2}`,
            isRight: false,
            isAnswered:
              answer2 != '' || a_images2 != '' || a_files2 != '' ? true : false,
            answerImages: `${a_images2}`,
            answerFiles: `${a_files2}`
          });
        });
        const ckValueStore = `${gidCurrent.current}|${examRecordIdCurrent.current}|${hid}|${tStore}|${JSON.stringify(answer_store2)}|${refeshNum}|${outExam}`;
        autoSaveStore(gidCurrent.current, ckValueStore);
      }
    }, 5000); // 5s save store

    if (status == false) {
      // save not internet
      clearTimeout(cTimeout);
      cTimeout = setTimeout(function () {
        autoSaveTest(0);
        //autoSaveTest(0, questionId, answer, "autoSaveTest");
        disconnectNum += 1;
        //setDisconnectNum(disconnectNum);
      }, 5000);
      return false;
    }

    //lưu hành trình
    TrackingTest(
      questionId,
      answer,
      action,
      { outExam: outExame, refeshNum: refeshNum, finish: finish },
      answers,
      t
    );

    // if(questionTypeId.current == 4){
    //   if(subjectId.current == 14 && action == "orientation_type"){// (orientationType == 1 || orientationType == 2)){// mon tin
    //     TrackingTestOrientation(questionId, answer, action, { outExam: outExame, refeshNum: refeshNum, finish: finish }, answers, t)
    //   } else {
    //     TrackingTest(questionId, answer, action, { outExam: outExame, refeshNum: refeshNum, finish: finish }, answers, t);
    //   }
    // }
    // else
    // {
    //   TrackingTest(0, "", action, { outExam: outExame, refeshNum: refeshNum, finish: finish }, answers, t);
    // }
    if (finish == 1) {
      if (status == false) {
        // save not internet
        clearTimeout(cTimeout);
        cTimeout = setTimeout(function () {
          autoSaveTest(1);
          //autoSaveTest(1, questionId, answer, "autoSaveTest");
          disconnectNum += 1;
        }, 5000);
        return false;
      } else {
        SubmitTest(answers, t);
      }
    }
  }

  async function finish(event, waitingSecond) {
    event.preventDefault();
    //if(statusExam.current == true) {return false;} // stop here
    //if (process.env.REACT_APP_ENABLEINFO == "1") {
    if (!offCheating.current) {
      if (disconnectNum >= 60) {
        // save 5s 1 lan =>5p
        // 5p khong internet
        swal({
          text: 'Đường truyền mạng không ổn định liên tục trong 5 phút. Bạn vui lòng liên hệ giáo viên để được hổ trợ.',
          icon: 'warning',
          buttons: ['Đóng', 'Liên hệ'],
          dangerMode: true
        }).then((willDelete) => {
          if (willDelete) {
            ClearCookie();
            window.location.href = linkExam;
          } else {
          }
        });

        // swal("", "Đường truyền mạng không ổn định liên tục trong 5 phút. Bạn vui lòng liên hệ giáo viên để được hổ trợ.", "warning", {
        //   button: "OK",
        // });
        return false;
      }

      var status = navigator.onLine;
      if (status == false) {
        swal(
          '',
          'Đường truyền mạng không ổn định. Bạn vui lòng liên hệ giáo viên để được hổ trợ. Nếu hết thời gian làm bài, vui lòng đợi 5 phút khi có mạng lại hệ thống sẽ tự động nộp bài.',
          'warning',
          {
            button: 'OK'
          }
        );
        clearTimeout(cTimeout);
        cTimeout = setTimeout(function () {
          autoSaveTest(1);
          disconnectNum += 1;
          //setDisconnectNum(disconnectNum);
        }, 5000);
        return false;
      }

      if (refeshNum > 3) {
        swal(
          '',
          'Bạn đã bấm F5 hoặc tải lại trình duyệt vượt quá 2 lần theo quy chế kiểm tra. Vui lòng liên hệ giáo viên để được hổ trợ.',
          'warning',
          {
            button: 'OK'
          }
        );
        return false;
      }

      if (outExam == 1) {
        swal(
          '',
          'Bạn đã làm việc ngoài trong thời gian kiểm tra. Vui lòng liên hệ giáo viên để được hổ trợ.',
          'warning',
          {
            button: 'OK'
          }
        );
        return false;
      }
    }
    const totalAnswer = $('.btnq-answered');
    console.log('Total Answer: ', totalAnswer.length);
    if (totalAnswer.length < totalQuestions) {
      current = $('#countDownTimeSeconds').text();
      currentMunute = $('#countDownTimeMunute').text();
      const message = `Bạn còn ${totalQuestions - totalAnswer.length} câu chưa trả lời. Thời gian còn (${getTime(getTime(currentMunute))} phút ${getTime(current)} giây). Bạn đồng ý nộp bài?`;

      $('#SpendTime').val(
        totalDurationsCurr.current * 60 - (currentMunute * 60 + current)
      );
      //$('#SpendTime').val(totalDurations * 60 - (currentMunute * 60 + current));

      swal({
        text: message,
        icon: 'warning',
        buttons: ['Đóng', 'Nộp bài'],
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          autoSaveTest(1, trackingQuestionId, trackingAnswer, 'finish');
        } else {
        }
      });

      // if (parseInt(waitingSecond) > 0) {
      //   // setTimeout(function () { autoSaveTest(1) }, waitingSecond);
      // }
    } else {
      $('#SpendTime').val(
        totalDurationsCurr.current * 60 - (currentMunute * 60 + current)
      );
      //$('#SpendTime').val(totalDurations * 60 - (currentMunute * 60 + current));
      // nộp bài
      if (parseInt(waitingSecond) > 0) {
        setTimeout(function () {
          autoSaveTest(1, trackingQuestionId, trackingAnswer, 'finish');
        }, waitingSecond);
      } else {
        autoSaveTest(1, trackingQuestionId, trackingAnswer, 'finish');
      }
    }
  }

  async function TrackingTest(
    question_id,
    answer,
    action,
    content,
    answers,
    spendTime
  ) {
    if (curStatus == 23) {
      // da nop bai
      window.location.href = `/xem-ket-qua-2025?id=${gid_applyId}`;
    }

    if (statusExam.current == true) {
      return false;
    } // stop here
    answers = `{${answers}}`;

    var body = {
      gid: gidCurrent.current, // gid,// global id được trả về từ danh sách bài thi
      exam_record_id: examRecordIdCurrent.current, // examRecordId,// bài làm đang làm lấy từ kết quả của API lúc lấy đề
      question_id: question_id, // câu hỏi đang chọn
      answer: answer, // câu trả lời của câu hỏi
      action: action, // sự kiện trong quá trình thi
      content: content, // nội dung của sự kiện đó gồm các quá trình chống gian lận
      answers: JSON.parse(answers), // {""question_id_1"": ""trả lời cho câu 1"", ""quest_id_2"": ""trả lời cho câu 2"",...}"
      spend_time: spendTime,
      client_timing: new Date().getTime()
    };
    const apiBaseUrl =
      config.getRootURL() + '/gd/v3/student_exams/tracking_test';
    await callApi(apiBaseUrl, 'POST', body, header)
      .then(function (response) {
        if (response == false) {
          return false;
        }
        if (response != undefined && response.data.data.status == 'success') {
        } else {
          return false;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async function TrackingTestOrientation(answer) {
    if (statusExam.current == true) {
      return false;
    } // stop here
    /* Rieng cho mon tin hoc
      Chọn phần riêng, thì gọi api tracking_test lun, với action = "orientation_type"
      answer = "1" hoặc "2" ==> 1 là chọn khoa học máy tính, 2 là tin học ứng dụng
    */

    // "gid: global id được trả về từ danh sách đề thi
    // exam_record_id: là last_exam_record_id của bài làm đang làm lấy từ kết quả của API lúc lấy đề
    // answer: ""1"" là hướng khoa học máy tính, ""2"" là tin học ứng dụng
    // action: ""orientation_type"""
    var body = {
      gid: gidCurrent.current, // gid,// global id được trả về từ danh sách bài thi
      exam_record_id: examRecordIdCurrent.current, // examRecordId,// bài làm đang làm lấy từ kết quả của API lúc lấy đề
      answer: answer + '', // câu trả lời của câu hỏi
      action: 'orientation_type' // sự kiện trong quá trình thi
    };
    const apiBaseUrl =
      config.getRootURL() + '/gd/v3/student_exams/choose_orientation';
    await callApi(apiBaseUrl, 'POST', body, header)
      .then(function (response) {
        if (response == false) {
          return false;
        }
        if (response != undefined && response.data.data.status == 'success') {
        } else {
          return false;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async function SubmitTest(answers, spendTime) {
    //if(statusExam.current == true) {return false;} // stop here
    answers = `{${answers}}`;

    var body = {
      gid: gidCurrent.current, // global id được trả về từ danh sách bài thi
      exam_record_id: examRecordIdCurrent.current, // bài làm đang làm lấy từ kết quả của API lúc lấy đề
      answers: JSON.parse(answers), // {""question_id_1"": ""trả lời cho câu 1"", ""quest_id_2"": ""trả lời cho câu 2"",...}"
      spend_time: spendTime,
      client_timing: new Date().getTime()
    };
    localStorage.setItem('bodyData', JSON.stringify(body));

    const apiBaseUrl = config.getRootURL() + '/gd/v3/student_exams/submit_test';
    await callApi(apiBaseUrl, 'POST', body, header)
      .then(function (response) {
        if (response == false) {
          swal(
            '',
            'Nộp bài không thành công. Bạn vui lòng liên hệ giáo viên để được hổ trợ.',
            'warning',
            {
              button: 'OK'
            }
          );
          return false;
        }
        if (response != undefined) {
          // "exam: thông tin thiết lập chi tiết của bài thi
          // questions: danh sách câu hỏi có chấm theo đáp án.
          // exam_record: bài làm của mỗi lần học sinh làm bài cho 1 bài thi
          // num_correct: số câu đúng
          // num_incorrect: số câu làm sai
          // num_unfinish: số câu chưa làm
          // score: điểm số"
          // window.location.href = `/xem-ket-qua-2025?id=${gidCurrent.current}`;

          // clear gia tri chong gian lan khi qua cac trang khac khong hien thi popup
          offCheating.current = true;
          history.push(`/xem-ket-qua-2025?id=${gidCurrent.current}`);
          // swal({
          //   text: "Chúc mừng bạn đã hoàn thành bài kiểm tra.",
          //   icon: "success",
          //   buttons: true,
          //   //dangerMode: true,
          // })
          // .then((willDelete) => {
          //   window.location.href = `/xem-ket-qua?id=${gid}`;
          // });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async function onChange(event) {
    event.preventDefault();

    var file = event.target.files[0];
    if (validateSize(event)) {
      if (
        file.type !=
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
        file.type != 'application/msword'
      ) {
        swal('', 'Vui lòng đúng chọn định dạng file word.', 'warning', {
          button: 'OK'
        });
        return false;
      }

      setFileUploadName({ selectedFile: file });
    }
  }
  function validateSize(event) {
    return true; // auto
    let file = event.target.files[0];
    let size = 10485760; // 10MB
    let err = '';
    if (file == '' || file == null) {
      return false;
    }
    if (file.size > size) {
      swal(
        '',
        'Kích thước file vượt quá 10MB, vui lòng chọn file kích thước nhỏ hơn.',
        'warning',
        {
          button: 'OK'
        }
      );
      return false;
    }
    return true;
  }

  var renderFileUploaded = [];
  function handleChangeFile(event, id, typeId) {
    if (!validateSize(event)) {
      return false;
    }

    var arrFileName = [];
    renderFileUploaded = [];
    const files = event.target.files;
    var extention = '';
    if (files.length > 20) {
      swal(
        '',
        'Số lượng upload vượt quá 20 file. Vui lòng kiểm tra lại.',
        'warning',
        {
          button: 'OK'
        }
      );
      return false;
    }
    for (let i = 0; i < files.length; i++) {
      //formData.append(`images[${i}]`, files[i])
      //switch (files[i].type.split('/')[1]) {
      switch (files[i].type) {
        case 'image/png':
          extention = '.png';
          break;
        case 'image/jpg':
          extention = '.jpg';
          break;
        case 'image/gif':
          extention = '.gif';
          break;
        case 'image/jpeg':
          extention = '.jpeg';
          break;
        case 'image/webp':
          extention = '.webp';
          break;
        case 'text/plain':
          extention = '.' + files[i].name.split('.')[1];
          //extention = ".txt";
          break;
        case 'application/pdf':
          extention = '.pdf';
          break;
        case 'application/msword':
          extention = '.doc';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          extention = '.docx';
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          extention = '.xlsx';
          break;
        case 'application/vnd.ms-excel':
          extention = '.xls';
          break;
        case 'audio/mpeg':
          extention = '.mp3';
          break;
        default:
          swal(
            '',
            'Định dạng file không đúng, vui lòng kiểm tra lại (Các định dạng file .png, .jpeg, .gif, .webp, .pdf, .doc, .docx, .txt, .xls, .xlsx, .mp3, .c, .h, .cs)',
            'warning',
            {
              button: 'OK'
            }
          );
          return false;
      }
      var uid = uuid();
      var filename = uid + extention;
      var pathname =
        typeId == 1
          ? 'anwsers/' +
            examRecordIdCurrent.current +
            '/' +
            id +
            '/images/' +
            filename
          : typeId == 2
            ? 'anwsers/' +
              examRecordIdCurrent.current +
              '/' +
              id +
              '/files/' +
              filename
            : '';
      arrFileName.push(pathname);
    }
    //file = file.slice(0, file.length - 1);
    if (typeId == 1) {
      //images
      var arrFileNameAll = [];
      var storeHidden = $('#hidden_images_' + id).val();
      if (_.isEmpty(storeHidden)) {
        arrFileNameAll = arrFileName;
      } else {
        //arrFileName = _.union(arrFileName, _.split(storeHidden, ',' )); //merge 2 array, check exists
        arrFileNameAll = _.union(arrFileName, _.split(storeHidden, ',')); //merge 2 array, check exists
        if (arrFileNameAll.length > 20) {
          swal(
            '',
            'Số lượng upload vượt quá 20 hình ảnh. Vui lòng kiểm tra lại.',
            'warning',
            {
              button: 'OK'
            }
          );
          return false;
        }
      }
      //$('#hidden_images_'+id).val(arrFileName);
      $('#hidden_images_' + id).val(arrFileNameAll);
    } else if (typeId == 2) {
      // files

      var arrFileNameAll = [];
      var storeHidden = $('#hidden_files_' + id).val();
      if (_.isEmpty(storeHidden)) {
        arrFileNameAll = arrFileName;
      } else {
        //arrFileName = _.union(arrFileName, _.split(storeHidden, ',' ));
        arrFileNameAll = _.union(arrFileName, _.split(storeHidden, ','));
        if (arrFileNameAll.length > 20) {
          swal(
            '',
            'Số lượng upload vượt quá 20 file. Vui lòng kiểm tra lại.',
            'warning',
            {
              button: 'OK'
            }
          );
          return false;
        }
      }
      //$('#hidden_files_'+id).val(arrFileName);
      $('#hidden_files_' + id).val(arrFileNameAll);
    }
    readfiles(event, files, arrFileName, arrFileNameAll, id, typeId);
  }

  async function readfiles(
    event,
    files,
    arrFileName,
    arrFileNameAll,
    id = 0,
    typeId = 0
  ) {
    //var fileCounter=files.length;
    //for (var file, i = 0; i < fileCounter; i++) {
    //file = files[i];
    // if(files[i].name && !files[i].name.match(/.(gif|jpe?g|png|svg)$/i)) {
    // 	alert("images only");
    // 	return;
    // }
    var body = {
      file_paths: arrFileName
    };
    const apiBaseUrl =
      config.getRootURL() + '/gd/v3/student_exams/presigned_upload_url';
    await callApi(apiBaseUrl, 'POST', body, header)
      .then(function (response) {
        if (response == false) {
          return false;
        }
        if (
          response != undefined &&
          response.data.data.presigned_urls != undefined
        ) {
          uploadFile(
            event,
            files,
            response.data.data.presigned_urls,
            id,
            typeId,
            arrFileNameAll
          );
        } else {
          return false;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function uploadFile(event, files, s3presignedUrl, id, typeId, arrFileName) {
    var fileCounter = files.length;
    //var fileCounter = arrFileName;
    for (var file, i = 0; i < fileCounter; i++) {
      file = files[i];
      var getKey = Object.keys(s3presignedUrl)[i];
      const apiBaseUrl = s3presignedUrl[getKey]; //.split('?')[0].substr(6);
      $.ajax({
        url: apiBaseUrl,
        type: 'PUT',
        data: file,
        dataType: 'text',
        cache: false,
        contentType: file.type,
        processData: false
      })
        .done(function () {
          //var newFileUrl = s3presignedUrl.split('?')[0].substr(6);
          renderFileUploaded.push(apiBaseUrl.split('?')[0]);
          var uid = uuid();
          if (typeId == 1) {
            $('#appendimages_' + id).append(
              `<div class="col-6 col-md-2 iw-upload-item" id='boximages_${uid}'>
              <input type="hidden" class='hiddenUpload_${id}_${typeId}' id='hiddenUpload_${uid}' name='hiddenUpload_${uid}' value='${'anwsers/' + apiBaseUrl.split('?')[0].split('/anwsers/')[1]}'/>
              <div class="iw-image-upload">
                <div class="iw-image-upload-inner ratio-1-1">
                  <img src='${apiBaseUrl.split('?')[0]}' alt="" />
                </div>
                <a href="javascript:void(0);" class="iw-image-upload-delete changeDelete" onclick="removeBoxImage('${uid}',${id}, 1 ,1)">
                  <i class="fas fa-times"></i>
                </a>
              </div>
            </div>`
            );
          } else if (typeId == 2) {
            $('#appendfiles_' + id).append(
              `<li id='boxfiles_${uid}'>
                <input type="hidden" class='hiddenUpload_${id}_${typeId}' id='hiddenUpload_${uid}' name='hiddenUpload_${uid}' value='${'anwsers/' + apiBaseUrl.split('?')[0].split('/anwsers/')[1]}'/>
                <i class="fas fa-file-alt"></i>
                <span class="line-1">${apiBaseUrl.split('?')[0].split('/files/')[1]}</span>
                <div class="iw-upload-file-action">
                  <a href="javascript:void(0);" class="changeDelete" onclick="removeBoxImage('${uid}',${id}, 1 ,2)">
                    <i class="fas fa-trash-alt"></i>
                  </a>
                </div>
              </li>`
            );
          }
          checkItemCK(`q_${id}`, id, '', 0);
          //checkItem(event, `q_${id}`, id);
        })
        .fail(function (e) {
          console.error('upload failed', e);
        });
    }
  }

  function removeBoxImage(uid, id, vl, type) {
    if (type == 1) {
      // image
      $('#boximages_' + uid).remove();
      var storeHidden = '';
      $('.hiddenUpload_' + id + '_' + type).each(function () {
        storeHidden += $(this).val() + ',';
      });
      storeHidden = storeHidden.slice(0, storeHidden.length - 1);
      $('#hidden_images_' + id).val(storeHidden);
    } else if (type == 2) {
      // files
      $('#boxfiles_' + uid).remove();
      var storeHidden = '';
      $('.hiddenUpload_' + id + '_' + type).each(function () {
        storeHidden += $(this).val() + ',';
      });
      storeHidden = storeHidden.slice(0, storeHidden.length - 1);
      $('#hidden_files_' + id).val(storeHidden);
    }
    autoSaveTest(0, id, '', 'checkItem');
  }

  function uploadIF(val, qId) {
    if (val == 'image') {
      $('#fileUpload_' + qId).trigger('click');
    } else {
      $('#fileUploadFiles_' + qId).trigger('click');
    }
  }

  const mathElements = [];
  // ['heading',
  //   '|',
  //   'bold',
  //   'italic',
  //   'underline',
  //   'strikethrough',
  //   'subscript',
  //   'superscript',
  //   '|',
  //   'bulletedList',
  //   'numberedList',
  //   'todoList',
  //   '|',
  //   'alignment',
  //   'outdent',
  //   'indent', '|', 'undo', 'redo'
  //   //,'MathType', 'ChemType'
  //   , '|',
  // ]
  var resetSTT = 0;
  var resetSTT1 = 0;
  var resetSTT2 = 0;

  const mathJaxConfig = {
    loader: { load: ['input/asciimath', 'output/chtml'] }
  };
  return (
    <div>
      <div className="wrapper disable-class">
        <div className="block-question-wrap pt-20">
          <div className="block-question">
            <div className="info-mb">
              <ul className="info">
                <li>
                  <strong>{username}</strong>
                </li>
                <li>{schoolname}</li>
                <li>
                  <strong>Phòng thi: {roomname}</strong>
                </li>
              </ul>
            </div>
            <h1 className="page-heading">
              Môn thi {subjectname} - {examname}
            </h1>
            <div className="page-body">
              {
                //questionTypeId.current == 4 ?
                questionArr?.map((question, num) => {
                  // Kiểm tra xem câu hỏi thuộc mảng nào
                  if (firstArray.includes(question)) {
                    resetSTT += 1;
                    return (
                      <div
                        className="qItem"
                        id={`questionRegionItem_${question.id}`}
                        style={
                          num > 0 ? { display: 'none' } : { display: 'block' }
                        }>
                        <h6>
                          <strong>
                            Phần I.
                            {showMessagePartTHPT(
                              subjectId.current,
                              1,
                              firstArray.length
                            )}
                          </strong>
                        </h6>
                        <br></br>
                        <div className="question-header">
                          <h2>
                            <span style={{ fontWeight: 'bold', color: 'blue' }}>
                              CÂU {resetSTT}{' '}
                            </span>
                          </h2>
                          {/* <h2><span style={{ fontWeight: 'bold', color: 'blue' }}>CÂU {num + 1} </span></h2> */}
                          {/* <a href="javascript:void(0);" data-toggle="modal" data-target="#noticalModal">Báo lỗi bài thi</a> */}
                        </div>
                        {question.content.replace(
                          /<style[^>]*>.*<\/style>/gm,
                          ''
                        ).length > 2000 ? (
                          <div
                            className="question overlay-scrollbar"
                            style={{ height: '210px' }}>
                            <MathJaxContext config={mathJaxConfig}>
                              <MathJax>
                                {HtmlParse(
                                  config.convertAllMfencedInHtml(
                                    question.content
                                      .split('<p>&nbsp;</p>')
                                      .join('')
                                  )
                                )}
                              </MathJax>
                            </MathJaxContext>
                          </div>
                        ) : (
                          <div
                            className="question overlay-scrollbar"
                            style={{ height: 'auto', marginBottom: '40px' }}>
                            <MathJaxContext config={mathJaxConfig}>
                              <MathJax>
                                {HtmlParse(
                                  config.convertAllMfencedInHtml(
                                    question.content
                                      .split('<p>&nbsp;</p>')
                                      .join('')
                                  )
                                )}
                              </MathJax>
                            </MathJaxContext>
                            {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                          </div>
                        )}
                        <div className="answer">
                          <input
                            type="hidden"
                            id={`hidden_${question.id}`}
                            name={`hidden_${question.id}`}
                            className="hiddenQIDCSS"
                            data-id={question.id}
                            defaultValue={question.answerOfStudent}
                          />
                          <ul>
                            <li
                              onClick={(e) => {
                                // document.getElementById(`q_${question.id}A`).click();
                                checkItem(e, `q_${question.id}A`, question.id);
                              }}
                              style={{ cursor: 'pointer' }}>
                              <input
                                style={{ marginBottom: 'auto' }}
                                id={`q_${question.id}A`}
                                key={`q_${question.id}A`}
                                defaultValue="A"
                                type="radio"
                                name={`radioGroup_${question.id}`}
                                defaultChecked={
                                  question.answerOfStudent == 'A' ? 'True' : ''
                                }
                              />
                              <label
                                htmlFor={`q_${question.id}A`}
                                style={{ display: '-webkit-flex' }}>
                                <strong>A.&nbsp;</strong>
                                <MathJaxContext config={mathJaxConfig}>
                                  <MathJax>
                                    {HtmlParse(
                                      config.convertAllMfencedInHtml(
                                        question.a1
                                          .split('<p>&nbsp;</p>')
                                          .join('')
                                      )
                                    )}
                                  </MathJax>
                                </MathJaxContext>

                                {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                              </label>
                            </li>
                            <li
                              onClick={(e) => {
                                // document.getElementById(`q_${question.id}B`).click();
                                checkItem(e, `q_${question.id}B`, question.id);
                              }}
                              style={{ cursor: 'pointer' }}>
                              <input
                                style={{ marginBottom: 'auto' }}
                                id={`q_${question.id}B`}
                                key={`q_${question.id}B`}
                                defaultValue="B"
                                type="radio"
                                name={`radioGroup_${question.id}`}
                                defaultChecked={
                                  question.answerOfStudent == 'B' ? 'True' : ''
                                }
                              />
                              <label
                                htmlFor={`q_${question.id}B`}
                                style={{ display: '-webkit-flex' }}>
                                <strong>B.&nbsp;</strong>
                                <MathJaxContext config={mathJaxConfig}>
                                  <MathJax>
                                    {HtmlParse(
                                      config.convertAllMfencedInHtml(
                                        question.a2
                                          .split('<p>&nbsp;</p>')
                                          .join('')
                                      )
                                    )}
                                  </MathJax>
                                </MathJaxContext>

                                {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                              </label>
                            </li>
                            <li
                              onClick={(e) => {
                                // document.getElementById(`q_${question.id}C`).click();
                                checkItem(e, `q_${question.id}C`, question.id);
                              }}
                              style={{ cursor: 'pointer' }}>
                              <input
                                style={{ marginBottom: 'auto' }}
                                id={`q_${question.id}C`}
                                key={`q_${question.id}C`}
                                defaultValue="C"
                                type="radio"
                                name={`radioGroup_${question.id}`}
                                defaultChecked={
                                  question.answerOfStudent == 'C' ? 'True' : ''
                                }
                              />
                              <label
                                htmlFor={`q_${question.id}C`}
                                style={{ display: '-webkit-flex' }}>
                                <strong>C.&nbsp;</strong>
                                {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                <MathJaxContext config={mathJaxConfig}>
                                  <MathJax>
                                    {HtmlParse(
                                      config.convertAllMfencedInHtml(
                                        question.a3
                                          .split('<p>&nbsp;</p>')
                                          .join('')
                                      )
                                    )}
                                  </MathJax>
                                </MathJaxContext>
                              </label>
                            </li>
                            <li
                              onClick={(e) => {
                                checkItem(e, `q_${question.id}D`, question.id);
                              }}
                              style={{ cursor: 'pointer' }}>
                              <input
                                style={{ marginBottom: 'auto' }}
                                id={`q_${question.id}D`}
                                key={`q_${question.id}D`}
                                defaultValue="D"
                                type="radio"
                                name={`radioGroup_${question.id}`}
                                defaultChecked={
                                  question.answerOfStudent == 'D' ? 'True' : ''
                                }
                              />
                              <label
                                htmlFor={`q_${question.id}D`}
                                style={{ display: '-webkit-flex' }}>
                                <strong>D.&nbsp;</strong>
                                {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                <MathJaxContext config={mathJaxConfig}>
                                  <MathJax>
                                    {HtmlParse(
                                      config.convertAllMfencedInHtml(
                                        question.a4
                                          .split('<p>&nbsp;</p>')
                                          .join('')
                                      )
                                    )}
                                  </MathJax>
                                </MathJaxContext>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    );
                  } else if (secondArray.includes(question)) {
                    resetSTT1 += 1;
                    if (subjectId.current == 14 && isFree.current == false) {
                      // tin hoc de thpt 2025
                      {
                        if (firstArraySubPart.includes(question)) {
                          return (
                            <div
                              className="qItem"
                              id={`questionRegionItem_${question.id}`}
                              style={
                                num > 0
                                  ? { display: 'none' }
                                  : { display: 'block' }
                              }>
                              <h6>
                                <p>
                                  <strong>
                                    Phần II.
                                    {showMessagePartTHPT(
                                      subjectId.current,
                                      2,
                                      secondArray.length
                                    )}
                                  </strong>
                                </p>
                                <strong>A/ Phần chung</strong>
                              </h6>
                              <br></br>
                              <div className="question-header">
                                <h2>
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      color: 'blue'
                                    }}>
                                    CÂU {resetSTT1}
                                  </span>
                                </h2>
                              </div>
                              {question.content.replace(
                                /<style[^>]*>.*<\/style>/gm,
                                ''
                              ).length > 2000 ? (
                                <div
                                  className="question overlay-scrollbar"
                                  style={{ height: '210px' }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}>
                                    <MathJax>
                                      {HtmlParse(
                                        config.convertAllMfencedInHtml(
                                          question.content
                                            .split('<p>&nbsp;</p>')
                                            .join('')
                                        )
                                      )}
                                    </MathJax>
                                  </MathJaxContext>
                                </div>
                              ) : (
                                <div
                                  className="question overlay-scrollbar"
                                  style={{
                                    height: 'auto',
                                    marginBottom: '40px'
                                  }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}>
                                    <MathJax>
                                      {HtmlParse(
                                        config.convertAllMfencedInHtml(
                                          question.content
                                            .split('<p>&nbsp;</p>')
                                            .join('')
                                        )
                                      )}
                                    </MathJax>
                                  </MathJaxContext>
                                </div>
                              )}
                              {
                                <div className="answer">
                                  <input
                                    type="hidden"
                                    id={`hidden_${question.id}`}
                                    name={`hidden_${question.id}`}
                                    className="hiddenQIDCSS"
                                    data-id={question.id}
                                    defaultValue={question.answerOfStudent}
                                  />
                                  {['a1', 'a2', 'a3', 'a4'].map(
                                    (item, nump2) => (
                                      <ul
                                        className="test-number-part2"
                                        key={item}>
                                        <li
                                          key={nump2}
                                          id={`quesItemPart2${question.id}${item}`}
                                          className={`qItemPart2-${question.id}`}
                                          // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                          style={
                                            nump2 > 0
                                              ? { display: 'block' }
                                              : { display: 'block' }
                                          }>
                                          {item === 'a1' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                a.{' '}
                                              </span>
                                              {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a1
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a2' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                b.{' '}
                                              </span>
                                              {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a2
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a3' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                c.{' '}
                                              </span>
                                              {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a3
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a4' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                d.{' '}
                                              </span>
                                              {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a4
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : (
                                            ''
                                          )}

                                          <ul
                                            className="answer-true-false"
                                            qid={`${question.id}`}>
                                            <li style={{ cursor: 'pointer' }}>
                                              <label
                                                htmlFor={`q_${question.id}ĐÚNG${item}`}
                                                style={{
                                                  display: '-webkit-flex'
                                                }}>
                                                <input
                                                  style={{
                                                    marginBottom: 'auto'
                                                  }}
                                                  id={`q_${question.id}ĐÚNG${item}`}
                                                  key={`q_${question.id}A`}
                                                  defaultValue="ĐÚNG"
                                                  type="radio"
                                                  name={`radioGroup_${question.id}${item}`}
                                                  onClick={(e) => {
                                                    checkItemPart2(
                                                      e,
                                                      `q_${question.id}ĐÚNG${item}`,
                                                      question.id,
                                                      item
                                                    );
                                                  }}
                                                />
                                                <strong>A. Đúng</strong>
                                              </label>
                                            </li>
                                            <li style={{ cursor: 'pointer' }}>
                                              <label
                                                htmlFor={`q_${question.id}SAI${item}`}
                                                style={{
                                                  display: '-webkit-flex'
                                                }}>
                                                <input
                                                  style={{
                                                    marginBottom: 'auto'
                                                  }}
                                                  id={`q_${question.id}SAI${item}`}
                                                  key={`q_${question.id}B`}
                                                  defaultValue="SAI"
                                                  type="radio"
                                                  name={`radioGroup_${question.id}${item}`}
                                                  onClick={(e) => {
                                                    checkItemPart2(
                                                      e,
                                                      `q_${question.id}SAI${item}`,
                                                      question.id,
                                                      item
                                                    );
                                                  }}
                                                />
                                                <strong>B. Sai</strong>
                                              </label>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </div>
                              }
                              {resetSTT1 >= 2 ? (
                                ''
                              ) : (
                                <ul
                                  className="test-number-next"
                                  style={{ textAlign: '-webkit-right' }}>
                                  <li
                                    id={`next2${question.id}`}
                                    style={{ width: '120px' }}>
                                    <a
                                      href="javascript:void(0)"
                                      className="next-part3"
                                      onClick={(e) => {
                                        checkItemNextPart2(
                                          e,
                                          `q_${question.id}`,
                                          question.id
                                        );
                                      }}>
                                      {'Tiếp theo >>'}
                                    </a>
                                  </li>
                                </ul>
                              )}
                            </div>
                          );
                        }
                        if (secondArraySubPart.includes(question)) {
                          return (
                            <div
                              className="qItem"
                              id={`questionRegionItem_${question.id}`}
                              style={
                                num > 0
                                  ? { display: 'none' }
                                  : { display: 'block' }
                              }>
                              <h6>
                                <p>
                                  <strong>
                                    Phần II.
                                    {showMessagePartTHPT(
                                      subjectId.current,
                                      2,
                                      secondArraySubPart.length
                                    )}
                                  </strong>
                                </p>
                                <strong>
                                  B/ Phần riêng: Định hướng khoa học máy tính
                                </strong>
                              </h6>
                              <br></br>
                              <div className="question-header">
                                <h2>
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      color: 'blue'
                                    }}>
                                    CÂU {resetSTT1}
                                  </span>
                                </h2>
                              </div>
                              {question.content.replace(
                                /<style[^>]*>.*<\/style>/gm,
                                ''
                              ).length > 2000 ? (
                                <div
                                  className="question overlay-scrollbar"
                                  style={{ height: '210px' }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}>
                                    <MathJax>
                                      {HtmlParse(
                                        config.convertAllMfencedInHtml(
                                          question.content
                                            .split('<p>&nbsp;</p>')
                                            .join('')
                                        )
                                      )}
                                    </MathJax>
                                  </MathJaxContext>
                                </div>
                              ) : (
                                <div
                                  className="question overlay-scrollbar"
                                  style={{
                                    height: 'auto',
                                    marginBottom: '40px'
                                  }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}>
                                    <MathJax>
                                      {HtmlParse(
                                        config.convertAllMfencedInHtml(
                                          question.content
                                            .split('<p>&nbsp;</p>')
                                            .join('')
                                        )
                                      )}
                                    </MathJax>
                                  </MathJaxContext>
                                </div>
                              )}
                              {
                                <div
                                  className={
                                    orientationType.current == 1
                                      ? 'answer'
                                      : 'answer'
                                  }>
                                  <input
                                    type="hidden"
                                    id={`hidden_${question.id}`}
                                    name={`hidden_${question.id}`}
                                    className="hiddenQIDCSS"
                                    data-id={question.id}
                                    defaultValue={question.answerOfStudent}
                                  />
                                  {['a1', 'a2', 'a3', 'a4'].map(
                                    (item, nump2) => (
                                      <ul className="test-number-part2">
                                        <li
                                          key={nump2}
                                          id={`quesItemPart2${question.id}${item}`}
                                          className={`qItemPart2-${question.id}`}
                                          // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                          style={
                                            nump2 > 0
                                              ? { display: 'block' }
                                              : { display: 'block' }
                                          }>
                                          {item === 'a1' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                a.{' '}
                                              </span>
                                              {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a1
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a2' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                b.{' '}
                                              </span>
                                              {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a2
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a3' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                c.{' '}
                                              </span>
                                              {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a3
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a4' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                d.{' '}
                                              </span>
                                              {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a4
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : (
                                            ''
                                          )}

                                          <ul
                                            className="answer-true-false"
                                            qid={`${question.id}`}>
                                            <li style={{ cursor: 'pointer' }}>
                                              <label
                                                htmlFor={`q_${question.id}ĐÚNG${item}`}
                                                style={{
                                                  display: '-webkit-flex'
                                                }}>
                                                <input
                                                  style={{
                                                    marginBottom: 'auto'
                                                  }}
                                                  id={`q_${question.id}ĐÚNG${item}`}
                                                  key={`q_${question.id}A`}
                                                  defaultValue="ĐÚNG"
                                                  type="radio"
                                                  name={`radioGroup_${question.id}${item}`}
                                                  onClick={(e) => {
                                                    checkItemPart2(
                                                      e,
                                                      `q_${question.id}ĐÚNG${item}`,
                                                      question.id,
                                                      item,
                                                      1
                                                    );
                                                  }}
                                                />
                                                <strong>A. Đúng</strong>
                                              </label>
                                            </li>
                                            <li style={{ cursor: 'pointer' }}>
                                              <label
                                                htmlFor={`q_${question.id}SAI${item}`}
                                                style={{
                                                  display: '-webkit-flex'
                                                }}>
                                                <input
                                                  style={{
                                                    marginBottom: 'auto'
                                                  }}
                                                  id={`q_${question.id}SAI${item}`}
                                                  key={`q_${question.id}B`}
                                                  defaultValue="SAI"
                                                  type="radio"
                                                  name={`radioGroup_${question.id}${item}`}
                                                  onClick={(e) => {
                                                    checkItemPart2(
                                                      e,
                                                      `q_${question.id}SAI${item}`,
                                                      question.id,
                                                      item,
                                                      1
                                                    );
                                                  }}
                                                />
                                                <strong>B. Sai</strong>
                                              </label>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </div>
                              }
                              {resetSTT1 >= 4 ? (
                                ''
                              ) : (
                                <ul
                                  className="test-number-next"
                                  style={{ textAlign: '-webkit-right' }}>
                                  <li
                                    id={`next2${question.id}`}
                                    style={{ width: '120px' }}>
                                    <a
                                      href="javascript:void(0)"
                                      className="next-part3"
                                      onClick={(e) => {
                                        checkItemNextPart2(
                                          e,
                                          `q_${question.id}`,
                                          question.id,
                                          1
                                        );
                                      }}>
                                      {'Tiếp theo >>'}
                                    </a>
                                  </li>
                                </ul>
                              )}
                            </div>
                          );
                        }
                        if (thirdArraySubPart.includes(question)) {
                          return (
                            <div
                              className="qItem"
                              id={`questionRegionItem_${question.id}`}
                              style={
                                num > 0
                                  ? { display: 'none' }
                                  : { display: 'block' }
                              }>
                              <h6>
                                <p>
                                  <strong>
                                    Phần II.{' '}
                                    {showMessagePartTHPT(
                                      subjectId.current,
                                      2,
                                      thirdArraySubPart.length
                                    )}
                                  </strong>
                                </p>
                                <strong>
                                  B/ Phần riêng: Định hướng Tin học ứng dụng
                                </strong>
                              </h6>
                              <br></br>
                              <div className="question-header">
                                <h2>
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      color: 'blue'
                                    }}>
                                    CÂU {resetSTT1}
                                  </span>
                                </h2>
                              </div>
                              {question.content.replace(
                                /<style[^>]*>.*<\/style>/gm,
                                ''
                              ).length > 2000 ? (
                                <div
                                  className="question overlay-scrollbar"
                                  style={{ height: '210px' }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}>
                                    <MathJax>
                                      {HtmlParse(
                                        config.convertAllMfencedInHtml(
                                          question.content
                                            .split('<p>&nbsp;</p>')
                                            .join('')
                                        )
                                      )}
                                    </MathJax>
                                  </MathJaxContext>
                                </div>
                              ) : (
                                <div
                                  className="question overlay-scrollbar"
                                  style={{
                                    height: 'auto',
                                    marginBottom: '40px'
                                  }}>
                                  {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                                  <MathJaxContext config={mathJaxConfig}>
                                    <MathJax>
                                      {HtmlParse(
                                        config.convertAllMfencedInHtml(
                                          question.content
                                            .split('<p>&nbsp;</p>')
                                            .join('')
                                        )
                                      )}
                                    </MathJax>
                                  </MathJaxContext>
                                </div>
                              )}
                              {
                                <div
                                  className={
                                    orientationType.current == 2
                                      ? 'answer'
                                      : 'answer'
                                  }>
                                  <input
                                    type="hidden"
                                    id={`hidden_${question.id}`}
                                    name={`hidden_${question.id}`}
                                    className="hiddenQIDCSS"
                                    data-id={question.id}
                                    defaultValue={question.answerOfStudent}
                                  />
                                  {['a1', 'a2', 'a3', 'a4'].map(
                                    (item, nump2) => (
                                      <ul className="test-number-part2">
                                        <li
                                          key={nump2}
                                          id={`quesItemPart2${question.id}${item}`}
                                          className={`qItemPart2-${question.id}`}
                                          // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                          style={
                                            nump2 > 0
                                              ? { display: 'block' }
                                              : { display: 'block' }
                                          }>
                                          {item === 'a1' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                a.{' '}
                                              </span>
                                              {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a1
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a2' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                b.{' '}
                                              </span>
                                              {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a2
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a3' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                c.{' '}
                                              </span>
                                              {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a3
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : item === 'a4' ? (
                                            <div style={{ display: 'flex' }}>
                                              {' '}
                                              <span
                                                style={{
                                                  paddingRight: '6px',
                                                  paddingLeft: '8px'
                                                }}>
                                                d.{' '}
                                              </span>
                                              {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                              <MathJaxContext
                                                config={mathJaxConfig}>
                                                <MathJax>
                                                  {HtmlParse(
                                                    config.convertAllMfencedInHtml(
                                                      question.a4
                                                        .split('<p>&nbsp;</p>')
                                                        .join('')
                                                    )
                                                  )}
                                                </MathJax>
                                              </MathJaxContext>
                                            </div>
                                          ) : (
                                            ''
                                          )}

                                          <ul
                                            className="answer-true-false"
                                            qid={`${question.id}`}>
                                            <li style={{ cursor: 'pointer' }}>
                                              <label
                                                htmlFor={`q_${question.id}ĐÚNG${item}`}
                                                style={{
                                                  display: '-webkit-flex'
                                                }}>
                                                <input
                                                  style={{
                                                    marginBottom: 'auto'
                                                  }}
                                                  id={`q_${question.id}ĐÚNG${item}`}
                                                  key={`q_${question.id}A`}
                                                  defaultValue="ĐÚNG"
                                                  type="radio"
                                                  name={`radioGroup_${question.id}${item}`}
                                                  onClick={(e) => {
                                                    checkItemPart2(
                                                      e,
                                                      `q_${question.id}ĐÚNG${item}`,
                                                      question.id,
                                                      item,
                                                      2
                                                    );
                                                  }}
                                                />
                                                <strong>A. Đúng</strong>
                                              </label>
                                            </li>
                                            <li style={{ cursor: 'pointer' }}>
                                              <label
                                                htmlFor={`q_${question.id}SAI${item}`}
                                                style={{
                                                  display: '-webkit-flex'
                                                }}>
                                                <input
                                                  style={{
                                                    marginBottom: 'auto'
                                                  }}
                                                  id={`q_${question.id}SAI${item}`}
                                                  key={`q_${question.id}B`}
                                                  defaultValue="SAI"
                                                  type="radio"
                                                  name={`radioGroup_${question.id}${item}`}
                                                  onClick={(e) => {
                                                    checkItemPart2(
                                                      e,
                                                      `q_${question.id}SAI${item}`,
                                                      question.id,
                                                      item,
                                                      2
                                                    );
                                                  }}
                                                />
                                                <strong>B. Sai</strong>
                                              </label>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </div>
                              }
                              {resetSTT1 >= 6 ? (
                                ''
                              ) : (
                                <ul
                                  className="test-number-next"
                                  style={{ textAlign: '-webkit-right' }}>
                                  <li
                                    id={`next2${question.id}`}
                                    style={{ width: '120px' }}>
                                    <a
                                      href="javascript:void(0)"
                                      className="next-part3"
                                      onClick={(e) => {
                                        checkItemNextPart2(
                                          e,
                                          `q_${question.id}`,
                                          question.id
                                        );
                                      }}>
                                      {'Tiếp theo >>'}
                                    </a>
                                  </li>
                                </ul>
                              )}
                            </div>
                          );
                        }
                      }
                      return (
                        <div
                          className="qItem"
                          id={`questionRegionItem_${question.id}`}
                          style={
                            num > 0 ? { display: 'none' } : { display: 'block' }
                          }>
                          <h6>
                            <strong>Phần II.</strong>
                            {showMessagePartTHPT(
                              subjectId.current,
                              2,
                              secondArray.length
                            )}
                            <strong>A/</strong>Phần chung
                          </h6>
                          <br></br>
                          <div className="question-header">
                            <h2>
                              <span
                                style={{ fontWeight: 'bold', color: 'blue' }}>
                                CÂU {resetSTT1}
                              </span>
                            </h2>
                          </div>
                          {question.content.replace(
                            /<style[^>]*>.*<\/style>/gm,
                            ''
                          ).length > 2000 ? (
                            <div
                              className="question overlay-scrollbar"
                              style={{ height: '210px' }}>
                              {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                              <MathJaxContext config={mathJaxConfig}>
                                <MathJax>
                                  {HtmlParse(
                                    config.convertAllMfencedInHtml(
                                      question.content
                                        .split('<p>&nbsp;</p>')
                                        .join('')
                                    )
                                  )}
                                </MathJax>
                              </MathJaxContext>
                            </div>
                          ) : (
                            <div
                              className="question overlay-scrollbar"
                              style={{ height: 'auto', marginBottom: '40px' }}>
                              {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                              <MathJaxContext config={mathJaxConfig}>
                                <MathJax>
                                  {HtmlParse(
                                    config.convertAllMfencedInHtml(
                                      question.content
                                        .split('<p>&nbsp;</p>')
                                        .join('')
                                    )
                                  )}
                                </MathJax>
                              </MathJaxContext>
                            </div>
                          )}
                          {
                            <div className="answer">
                              <input
                                type="hidden"
                                id={`hidden_${question.id}`}
                                name={`hidden_${question.id}`}
                                className="hiddenQIDCSS"
                                data-id={question.id}
                                defaultValue={question.answerOfStudent}
                              />
                              {['a1', 'a2', 'a3', 'a4'].map((item, nump2) => (
                                <ul className="test-number-part2">
                                  <li
                                    key={nump2}
                                    id={`quesItemPart2${question.id}${item}`}
                                    className={`qItemPart2-${question.id}`}
                                    // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                    style={
                                      nump2 > 0
                                        ? { display: 'block' }
                                        : { display: 'block' }
                                    }>
                                    {item === 'a1' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          a.{' '}
                                        </span>
                                        {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a1
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : item === 'a2' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          b.{' '}
                                        </span>
                                        {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a2
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : item === 'a3' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          c.{' '}
                                        </span>
                                        {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a3
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : item === 'a4' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          d.{' '}
                                        </span>
                                        {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a4
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : (
                                      ''
                                    )}

                                    <ul
                                      className="answer-true-false"
                                      qid={`${question.id}`}>
                                      <li style={{ cursor: 'pointer' }}>
                                        <label
                                          htmlFor={`q_${question.id}ĐÚNG${item}`}
                                          style={{ display: '-webkit-flex' }}>
                                          <input
                                            style={{ marginBottom: 'auto' }}
                                            id={`q_${question.id}ĐÚNG${item}`}
                                            key={`q_${question.id}A`}
                                            defaultValue="ĐÚNG"
                                            type="radio"
                                            name={`radioGroup_${question.id}${item}`}
                                            onClick={(e) => {
                                              checkItemPart2(
                                                e,
                                                `q_${question.id}ĐÚNG${item}`,
                                                question.id,
                                                item
                                              );
                                            }}
                                          />
                                          <strong>A. Đúng</strong>
                                        </label>
                                      </li>
                                      <li style={{ cursor: 'pointer' }}>
                                        <label
                                          htmlFor={`q_${question.id}SAI${item}`}
                                          style={{ display: '-webkit-flex' }}>
                                          <input
                                            style={{ marginBottom: 'auto' }}
                                            id={`q_${question.id}SAI${item}`}
                                            key={`q_${question.id}B`}
                                            defaultValue="SAI"
                                            type="radio"
                                            name={`radioGroup_${question.id}${item}`}
                                            onClick={(e) => {
                                              checkItemPart2(
                                                e,
                                                `q_${question.id}SAI${item}`,
                                                question.id,
                                                item
                                              );
                                            }}
                                          />
                                          <strong>B. Sai</strong>
                                        </label>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              ))}
                            </div>
                          }
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className="qItem"
                          id={`questionRegionItem_${question.id}`}
                          style={
                            num > 0 ? { display: 'none' } : { display: 'block' }
                          }>
                          <h6>
                            <strong>Phần II.</strong>
                            {showMessagePartTHPT(
                              subjectId.current,
                              2,
                              secondArray.length
                            )}
                          </h6>
                          <br></br>
                          <div className="question-header">
                            <h2>
                              <span
                                style={{ fontWeight: 'bold', color: 'blue' }}>
                                {/* CÂU {num + 1}  */}
                                CÂU {resetSTT1}
                              </span>
                            </h2>
                          </div>
                          {question.content.replace(
                            /<style[^>]*>.*<\/style>/gm,
                            ''
                          ).length > 2000 ? (
                            <div
                              className="question overlay-scrollbar"
                              style={{ height: '210px' }}>
                              {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                              <MathJaxContext config={mathJaxConfig}>
                                <MathJax>
                                  {HtmlParse(
                                    config.convertAllMfencedInHtml(
                                      question.content
                                        .split('<p>&nbsp;</p>')
                                        .join('')
                                    )
                                  )}
                                </MathJax>
                              </MathJaxContext>
                            </div>
                          ) : (
                            <div
                              className="question overlay-scrollbar"
                              style={{ height: 'auto', marginBottom: '40px' }}>
                              {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                              <MathJaxContext config={mathJaxConfig}>
                                <MathJax>
                                  {HtmlParse(
                                    config.convertAllMfencedInHtml(
                                      question.content
                                        .split('<p>&nbsp;</p>')
                                        .join('')
                                    )
                                  )}
                                </MathJax>
                              </MathJaxContext>
                            </div>
                          )}
                          {
                            <div className="answer">
                              <input
                                type="hidden"
                                id={`hidden_${question.id}`}
                                name={`hidden_${question.id}`}
                                className="hiddenQIDCSS"
                                data-id={question.id}
                                defaultValue={question.answerOfStudent}
                              />
                              {['a1', 'a2', 'a3', 'a4'].map((item, nump2) => (
                                <ul className="test-number-part2">
                                  <li
                                    key={nump2}
                                    id={`quesItemPart2${question.id}${item}`}
                                    className={`qItemPart2-${question.id}`}
                                    // style={nump2 > 0 ? { display: 'none' } : { display: 'block' }}
                                    style={
                                      nump2 > 0
                                        ? { display: 'block' }
                                        : { display: 'block' }
                                    }>
                                    {item === 'a1' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          a.{' '}
                                        </span>
                                        {/* <MathJax math={question.a1.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a1
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : item === 'a2' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          b.{' '}
                                        </span>
                                        {/* <MathJax math={question.a2.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a2
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : item === 'a3' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          c.{' '}
                                        </span>
                                        {/* <MathJax math={question.a3.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a3
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : item === 'a4' ? (
                                      <div style={{ display: 'flex' }}>
                                        {' '}
                                        <span
                                          style={{
                                            paddingRight: '6px',
                                            paddingLeft: '8px'
                                          }}>
                                          d.{' '}
                                        </span>
                                        {/* <MathJax math={question.a4.split('<p>&nbsp;</p>').join('')} /> */}
                                        <MathJaxContext config={mathJaxConfig}>
                                          <MathJax>
                                            {HtmlParse(
                                              config.convertAllMfencedInHtml(
                                                question.a4
                                                  .split('<p>&nbsp;</p>')
                                                  .join('')
                                              )
                                            )}
                                          </MathJax>
                                        </MathJaxContext>
                                      </div>
                                    ) : (
                                      ''
                                    )}

                                    <ul
                                      className="answer-true-false"
                                      qid={`${question.id}`}>
                                      <li style={{ cursor: 'pointer' }}>
                                        <label
                                          htmlFor={`q_${question.id}ĐÚNG${item}`}
                                          style={{ display: '-webkit-flex' }}>
                                          <input
                                            style={{ marginBottom: 'auto' }}
                                            id={`q_${question.id}ĐÚNG${item}`}
                                            key={`q_${question.id}A`}
                                            defaultValue="ĐÚNG"
                                            type="radio"
                                            name={`radioGroup_${question.id}${item}`}
                                            onClick={(e) => {
                                              checkItemPart2(
                                                e,
                                                `q_${question.id}ĐÚNG${item}`,
                                                question.id,
                                                item
                                              );
                                            }}
                                          />
                                          <strong>A. Đúng</strong>
                                        </label>
                                      </li>
                                      <li style={{ cursor: 'pointer' }}>
                                        <label
                                          htmlFor={`q_${question.id}SAI${item}`}
                                          style={{ display: '-webkit-flex' }}>
                                          <input
                                            style={{ marginBottom: 'auto' }}
                                            id={`q_${question.id}SAI${item}`}
                                            key={`q_${question.id}B`}
                                            defaultValue="SAI"
                                            type="radio"
                                            name={`radioGroup_${question.id}${item}`}
                                            onClick={(e) => {
                                              checkItemPart2(
                                                e,
                                                `q_${question.id}SAI${item}`,
                                                question.id,
                                                item
                                              );
                                            }}
                                          />
                                          <strong>B. Sai</strong>
                                        </label>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              ))}
                            </div>
                          }
                          <ul
                            className="test-number-next"
                            style={{ textAlign: '-webkit-right' }}>
                            <li
                              id={`next2${question.id}`}
                              style={{ width: '120px' }}>
                              <a
                                href="javascript:void(0)"
                                className="next-part3"
                                onClick={(e) => {
                                  checkItemNextPart2(
                                    e,
                                    `q_${question.id}`,
                                    question.id
                                  );
                                }}>
                                {'Tiếp theo >>'}
                              </a>
                            </li>
                          </ul>
                        </div>
                      );
                    }
                  } else if (thirdArray.includes(question)) {
                    resetSTT2 += 1;
                    return (
                      <div
                        className="qItem"
                        id={`questionRegionItem_${question.id}`}
                        style={
                          num > 0 ? { display: 'none' } : { display: 'block' }
                        }>
                        <h6>
                          <strong>Phần III.</strong>
                          {showMessagePartTHPT(
                            subjectId.current,
                            3,
                            thirdArray.length
                          )}
                        </h6>
                        <br></br>
                        <div className="question-header">
                          <h2>
                            <span style={{ fontWeight: 'bold', color: 'blue' }}>
                              {/* CÂU {num + 1}  */}
                              CÂU {resetSTT2}
                            </span>
                          </h2>
                          {/* <a href="javascript:void(0);" data-toggle="modal" data-target="#noticalModal">Báo lỗi bài thi</a> */}
                        </div>
                        {question.content.replace(
                          /<style[^>]*>.*<\/style>/gm,
                          ''
                        ).length > 2000 ? (
                          <div
                            className="question overlay-scrollbar"
                            style={{ height: '210px' }}>
                            {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                            <MathJaxContext config={mathJaxConfig}>
                              <MathJax>
                                {HtmlParse(
                                  config.convertAllMfencedInHtml(
                                    question.content
                                      .split('<p>&nbsp;</p>')
                                      .join('')
                                  )
                                )}
                              </MathJax>
                            </MathJaxContext>
                          </div>
                        ) : (
                          <div
                            className="question overlay-scrollbar"
                            style={{ height: 'auto', marginBottom: '40px' }}>
                            {/* <MathJax math={question.content.split('<p>&nbsp;</p>').join('')} /> */}
                            <MathJaxContext config={mathJaxConfig}>
                              <MathJax>
                                {HtmlParse(
                                  config.convertAllMfencedInHtml(
                                    question.content
                                      .split('<p>&nbsp;</p>')
                                      .join('')
                                  )
                                )}
                              </MathJax>
                            </MathJaxContext>
                          </div>
                        )}
                        <div className={`answer edi_${question.id}`}>
                          <input
                            type="hidden"
                            id={`hidden_${question.id}`}
                            name={`hidden_${question.id}`}
                            className="hiddenQIDCSS"
                            data-id={question.id}
                            defaultValue={question.answerOfStudent}
                          />
                          {/* <CKEditor
                              className={`q_${question.id}`}
                              editor={ClassicEditor}
                              data={getDataFromArrQuestion(answerPart3Prev, question.id)}
                              config={{
                                //plugins: [ ImageResize ],
                                toolbar: mathElements
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                checkItemCK(`q_${question.id}`, question.id, data, 1);
                              }}
                            /> */}
                          <textarea
                            className={`q_${question.id} input-textarea`}
                            rows="1"
                            cols="50"
                            style={{
                              width: '100%',
                              borderRadius: '8px',
                              border: '1px solid #ccc',
                              padding: '10px',
                              boxSizing: 'border-box'
                            }}
                            // value={getDataFromArrQuestion(answerPart3Prev, question.id)}
                            defaultValue={question.answerOfStudent}
                            onChange={(event) => {
                              const data = event.target.value;
                              //const newvalue = _.replace(data, /[^0-9.,;/+\-[]=()%]/g, '')
                              const newvalue = _.replace(
                                data,
                                /[^0-9.,;/+\-=\[\]()%]/g,
                                ''
                              );
                              //checkItemCK(`q_${question.id}`, question.id, data.trim(), 1);
                              $(`#hidden_${question.id}`).val(newvalue);
                              event.target.value = newvalue;
                            }}
                            //id={'textarea_'+question.id}
                            //onChange={(event) => handleChangeTextarea(event, question.id)}
                            placeholder="Nhập đáp án ở đây">
                            {/* {getDataFromArrQuestion(answerPart3Prev, question.id)} */}
                          </textarea>
                        </div>
                        <ul
                          className="test-number-next"
                          style={{ textAlign: '-webkit-right' }}>
                          <li
                            // onClick={e => {addClass(e, question.id)}}
                            id={`next3${question.id}`}
                            style={{ width: '165px' }}>
                            <a
                              href="javascript:void(0)"
                              className="next-part3"
                              onClick={(e) => {
                                checkItemNextPart3(
                                  e,
                                  `q_${question.id}`,
                                  question.id
                                );
                              }}>
                              {/* {resetSTT2 < 6 ? "Lưu & Tiếp theo >>" : "Lưu"} */}
                              {resetSTT2 < thirdArray.length
                                ? 'Lưu & Tiếp theo >>'
                                : 'Lưu'}
                            </a>
                          </li>
                        </ul>
                      </div>
                    );
                  }
                })
                //  : "Định dạng bài thi không đúng. Vui lòng liên hệ giáo viên để được hổ trợ1."
              }
            </div>
          </div>
          <div className="block-question-info">
            <div className="info-inner">
              <ul className="info">
                <li>
                  <strong>{username}</strong>
                </li>
                <li>{schoolname}</li>
                <li>
                  <strong>Phòng thi: {roomname}</strong>
                </li>
              </ul>
              <div className="time-countdown-new">
                <h3>THỜI GIAN LÀM BÀI</h3>
                <ul id="countdown">
                  <li>
                    <span id="countDownTimeMunute">{currentMunutes}</span>
                  </li>
                  <li className="dots">
                    <span>:</span>
                  </li>
                  <li>
                    <span id="countDownTimeSeconds">
                      {
                        currentSeconds
                        //(60 - (parseInt(spendTime) % 60))
                      }
                    </span>
                  </li>
                </ul>
              </div>
              {/* Click câu để thay đổi câu hỏi */}
              {/* Phần 1 */}
              {firstArray.length > 0 ? (
                <div className="questions-part1">
                  <h3>Phần I</h3>
                  <ul className="test-number">
                    {firstArray?.map((question, num) => (
                      <li
                        className={
                          num == 0 && question.isAnswered == false
                            ? 'btnq btnq-active'
                            : question.isAnswered == false
                              ? 'btnq'
                              : 'btnq btnq-answered active'
                        }
                        onClick={(e) => {
                          addClass(e, question.id);
                        }}
                        id={`q_btn_${question.id}`}
                        qid={question.id}
                        attrindex={num == 0 ? 1 : num + 1}>
                        <a href="javascript:void(0)">
                          {`${num < 9 ? `0${num + 1}` : num + 1}`}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                ''
              )}
              {/* Phần 2 */}
              {secondArray.length > 0 ? (
                <div className="questions-part2">
                  <h3>Phần II</h3>
                  {secondArray?.map((question, num) =>
                    subjectId.current == 14 && isFree.current == false ? ( // tin hoc, de thpt 2025
                      <>
                        {num == 0 ? <h3>A/ Phần chung</h3> : ''}
                        {firstArraySubPart.includes(question) ? (
                          <>
                            <div className="question-item">
                              <span className="question-number">
                                <a href="javascript:void(0)">
                                  {`${num < 5 ? `0${num + 1}` : num + 1}`}
                                </a>
                              </span>
                              <ul className="test-number">
                                {['a1', 'a2', 'a3', 'a4'].map((item, index) => (
                                  <li
                                    key={index}
                                    className={`btnq click_ans_${question.id}${item}  ${
                                      item == 'a1'
                                        ? question.isAnswereda1 == true
                                          ? 'btnq-answered'
                                          : ''
                                        : item == 'a2'
                                          ? question.isAnswereda2 == true
                                            ? 'btnq-answered'
                                            : ''
                                          : item == 'a3'
                                            ? question.isAnswereda3 == true
                                              ? 'btnq-answered'
                                              : ''
                                            : item == 'a4'
                                              ? question.isAnswereda4 == true
                                                ? 'btnq-answered'
                                                : ''
                                              : ''
                                    }`}
                                    onClick={(e) => {
                                      addClassPart2(e, question.id, item);
                                    }}
                                    id={`q_btn_${question.id}${item}`}
                                    qid={question.id}
                                    attrindex={num == 0 ? 1 : num + 1}>
                                    {['a', 'b', 'c', 'd'][index]}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : (
                          ''
                        )}
                        {num == 2 ? (
                          <div className="answer">
                            <h3>B/ Phần riêng</h3>
                            <ul
                              className="test-number-part2"
                              style={{ cursor: 'pointer' }}>
                              <ul qid={`${question.id}`}>
                                <li
                                  style={{
                                    cursor: 'auto',
                                    display: '-webkit-box',
                                    paddingLeft: '30px'
                                  }}>
                                  <p>
                                    <input
                                      onClick={(e) => {
                                        //checkOrientation(e,question.id, 1,1)
                                        addClassPart2(
                                          e,
                                          question.id,
                                          'a1',
                                          1,
                                          1
                                        );
                                      }}
                                      style={{ transform: 'scale(1.4)' }}
                                      defaultChecked={
                                        orientationType.current == 1
                                          ? true
                                          : false
                                      }
                                      id={`tinhoc_${question.id}_1`}
                                      key={`q_${question.id}_1`}
                                      value={1}
                                      type="radio"
                                      name={`tinhocGroup`}
                                    />
                                  </p>
                                  <label
                                    htmlFor={`tinhoc_${question.id}_1`}
                                    style={{ paddingLeft: '10px' }}>
                                    <strong>
                                      Định hướng khoa học máy tính
                                    </strong>
                                  </label>
                                </li>
                              </ul>
                            </ul>
                          </div>
                        ) : (
                          ''
                        )}
                        {secondArraySubPart.includes(question) ? (
                          <>
                            <div
                              className={
                                orientationType.current == 1
                                  ? 'question-item div-orientation-1'
                                  : 'question-item disabledDiv div-orientation-1'
                              }
                              id="div-orientation-1">
                              <span className="question-number">
                                <a href="javascript:void(0)">
                                  {`${num < 9 ? `0${num + 1}` : num + 1}`}
                                </a>
                              </span>
                              <ul className="test-number">
                                {['a1', 'a2', 'a3', 'a4'].map((item, index) => (
                                  <li
                                    key={index}
                                    className={`btnq click_ans_${question.id}${item}  ${
                                      item == 'a1'
                                        ? question.isAnswereda1 == true
                                          ? 'btnq-answered'
                                          : ''
                                        : item == 'a2'
                                          ? question.isAnswereda2 == true
                                            ? 'btnq-answered'
                                            : ''
                                          : item == 'a3'
                                            ? question.isAnswereda3 == true
                                              ? 'btnq-answered'
                                              : ''
                                            : item == 'a4'
                                              ? question.isAnswereda4 == true
                                                ? 'btnq-answered'
                                                : ''
                                              : ''
                                    }`}
                                    onClick={(e) => {
                                      addClassPart2(e, question.id, item, 1);
                                    }}
                                    id={`q_btn_${question.id}${item}`}
                                    qid={question.id}
                                    attrindex={num == 0 ? 1 : num + 1}>
                                    {['a', 'b', 'c', 'd'][index]}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : (
                          ''
                        )}
                        {num == 4 ? (
                          <div className="answer">
                            <h3>B/ Phần riêng</h3>
                            <ul
                              className="test-number-part2"
                              style={{ cursor: 'pointer' }}>
                              <ul qid={`${question.id}`}>
                                <li
                                  style={{
                                    cursor: 'auto',
                                    display: '-webkit-box',
                                    paddingLeft: '30px'
                                  }}>
                                  <p>
                                    <input
                                      onClick={(e) => {
                                        addClassPart2(
                                          e,
                                          question.id,
                                          'a1',
                                          2,
                                          2
                                        );
                                        //checkOrientation(e, question.id, 2,2)
                                      }}
                                      style={{ transform: 'scale(1.4)' }}
                                      defaultChecked={
                                        orientationType.current == 2
                                          ? true
                                          : false
                                      }
                                      id={`tinhoc_${question.id}_2`}
                                      key={`q_${question.id}_2`}
                                      value={2}
                                      type="radio"
                                      name={`tinhocGroup`}
                                    />
                                  </p>
                                  <label
                                    htmlFor={`tinhoc_${question.id}_2`}
                                    style={{ paddingLeft: '10px' }}>
                                    <strong>Định hướng Tin học ứng dụng</strong>
                                  </label>
                                </li>
                              </ul>
                            </ul>
                          </div>
                        ) : (
                          ''
                        )}
                        {thirdArraySubPart.includes(question) ? (
                          <>
                            <div
                              className={
                                orientationType.current == 2
                                  ? 'question-item div-orientation-2'
                                  : 'question-item disabledDiv div-orientation-2'
                              }
                              id="div-orientation-2">
                              <span className="question-number">
                                <a href="javascript:void(0)">
                                  {`${num < 9 ? `0${num + 1}` : num + 1}`}
                                </a>
                              </span>
                              <ul className="test-number">
                                {['a1', 'a2', 'a3', 'a4'].map((item, index) => (
                                  <li
                                    key={index}
                                    className={`btnq click_ans_${question.id}${item}  ${
                                      item == 'a1'
                                        ? question.isAnswereda1 == true
                                          ? 'btnq-answered'
                                          : ''
                                        : item == 'a2'
                                          ? question.isAnswereda2 == true
                                            ? 'btnq-answered'
                                            : ''
                                          : item == 'a3'
                                            ? question.isAnswereda3 == true
                                              ? 'btnq-answered'
                                              : ''
                                            : item == 'a4'
                                              ? question.isAnswereda4 == true
                                                ? 'btnq-answered'
                                                : ''
                                              : ''
                                    }`}
                                    onClick={(e) => {
                                      addClassPart2(e, question.id, item, 2);
                                    }}
                                    id={`q_btn_${question.id}${item}`}
                                    qid={question.id}
                                    attrindex={num == 0 ? 1 : num + 1}>
                                    {['a', 'b', 'c', 'd'][index]}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : (
                          ''
                        )}
                      </>
                    ) : (
                      <>
                        <div className="question-item">
                          <span className="question-number">
                            <a href="javascript:void(0)">
                              {`${num < 9 ? `0${num + 1}` : num + 1}`}
                            </a>
                          </span>
                          <ul className="test-number">
                            {['a1', 'a2', 'a3', 'a4'].map((item, index) => (
                              <li
                                key={index}
                                className={`btnq click_ans_${question.id}${item}  ${
                                  item == 'a1'
                                    ? question.isAnswereda1 == true
                                      ? 'btnq-answered'
                                      : ''
                                    : item == 'a2'
                                      ? question.isAnswereda2 == true
                                        ? 'btnq-answered'
                                        : ''
                                      : item == 'a3'
                                        ? question.isAnswereda3 == true
                                          ? 'btnq-answered'
                                          : ''
                                        : item == 'a4'
                                          ? question.isAnswereda4 == true
                                            ? 'btnq-answered'
                                            : ''
                                          : ''
                                }`}
                                onClick={(e) => {
                                  addClassPart2(e, question.id, item);
                                }}
                                id={`q_btn_${question.id}${item}`}
                                qid={question.id}
                                attrindex={num == 0 ? 1 : num + 1}>
                                {['a', 'b', 'c', 'd'][index]}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </>
                    )
                  )}
                </div>
              ) : (
                ''
              )}
              {/* Phần 3 */}
              {thirdArray.length > 0 ? (
                <div className="questions-part1">
                  <h3>Phần III</h3>
                  <ul className="test-number">
                    {thirdArray?.map((question, num) => (
                      <li
                        className={
                          num == 0 && question.isAnswered == false
                            ? 'btnq'
                            : question.isAnswered == false
                              ? 'btnq'
                              : 'btnq btnq-answered active'
                        }
                        onClick={(e) => {
                          addClass(e, question.id);
                        }}
                        id={`q_btn_${question.id}`}
                        qid={question.id}
                        attrindex={num == 0 ? 1 : num + 1}>
                        <a href="javascript:void(0)">
                          {`${num < 9 ? `0${num + 1}` : num + 1}`}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className="button-wrap">
              <a
                href="javascript:void(0);"
                className="btn"
                data-toggle="modal"
                onClick={(e) => finish(e, 1)}>
                Nộp bài
              </a>
              <br></br>

              <marquee>
                <div id="showhidestatusonline" style={{ display: 'none' }}>
                  Đường truyền mạng không ổn định. Vui lòng kiểm tra lại đường
                  kết nối mạng, wifi, 3G, 4G.
                </div>
              </marquee>
            </div>
            <input
              type="hidden"
              id="NumOfQuestion"
              name="NumOfQuestion"
              defaultValue={numOfQuestions}
            />
            <input
              type="hidden"
              id="Duration"
              name="Duration"
              defaultValue={durations}
            />
            <input type="hidden" id="ClassId" name="ClassId" />
            <input type="hidden" id="SubjectId" name="SubjectId" />
            <input
              type="hidden"
              id="SpendTime"
              name="SpendTime"
              defaultValue={spendTime}
            />
          </div>
        </div>
      </div>
      <div>
        {/* Thông đường truyền mạng */}
        <div
          className="modal fade iwe-modal"
          id="submitCountdownModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="submitCountdownModal">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Thông báo!
                </h5>
              </div>
              <div className="modal-body">
                Bài thi bắt đầu sau 15 giây:{' '}
                <Countdown
                  date={
                    Date.now() + parseInt(process.env.REACT_APP_COUNTDOWN_EXAM)
                  }
                  renderer={renderer}
                />
              </div>
              <div className="modal-footer">
                <a
                  href="javascript:void(0);"
                  className="btn"
                  data-dismiss="modal">
                  Đóng
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

StudentExamTHPT2025.propTypes = {
  history: PropTypes.object
};

export default withRouter(StudentExamTHPT2025);
